import { React, useEffect, useRef, useState } from "react";
import Navbar from "../Components/Navbar";
import DashBoardNavbar from "../Components/DashBoardNavbar";
import HomePageNavbarFinancials from "../Components/HomePageNavbarFinancials";
import axios from "axios";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../Components/Loading";
import moment from "moment";
import { setDivision } from "../Redux/Action/division";
import { Link, useLocation, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import LoadingSpinner from "../Components/Loader/UploadLoader";
import { IoFastFoodOutline } from "react-icons/io5";
import { IoClose } from "react-icons/io5";
import { FaShoppingCart } from "react-icons/fa";
import { FaCheck } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { MdPreview } from "react-icons/md";
import Receipt from "./Receipt";
import HomePage from "./HomePage";
import BILLSPLITTING from "./ORDERTAKER/BILLSPLITTING";
import BILLMERGING from "./ORDERTAKER/BILLMERGING";

const CreditNoteCash = ({ ordernoToPass, hideNavbar }) => {
  const BASEURL = process.env.REACT_APP_BASEURL;
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL_REPORTS = process.env.REACT_APP_BASEURL_REPORTS;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.changeTheState.user);
  const email = userState?.emailId;
  const divisionState = useSelector((state) => state.changeDivision);
  const [division, setdivsion] = useState(divisionState);
  const userid = userState?.emailId?.split("@")[0]?.toUpperCase();
  const orderNoRecieved = "";
  const [itemsListFromTakeOrder, setItemListFromTakeOrder] = useState([]);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const navigate = useNavigate();
  const [date, setDate] = useState(new Date()?.toISOString());
  const [newCashPOSNo, setnewCashPOSNo] = useState(null);
  const [seatingFlag, setSeatingFlag] = useState(null);
  const [listoftables, setlistoftables] = useState([]);
  const [seltable, setseltable] = useState("");
  const [listofservers, setlistofservers] = useState([]);
  const [selservername, setselservername] = useState(userid);
  const [listofProducts, setListOfProducts] = useState([]);
  const [selProductname, setselProductname] = useState("");
  const [Rate, setRate] = useState("");
  const [rateexc, setrateexc] = useState("");
  const [Quantity, setQuantity] = useState("");
  const [actualQuantity, setActualQuantity] = useState("");
  const [levyflag, setlevyflag] = useState(false);
  const [levyamt, setlevyamt] = useState(null);
  const [levyperc, setlevyperc] = useState(2);
  const [vatflag, setvatflag] = useState(false);
  const [vatamt, setvatamt] = useState(null);
  const [hvatamt, sethvatamt] = useState("");
  const [hlevyamt, sethlevyamt] = useState("");
  const [hlevyperc, sethlevyperc] = useState("");
  const [hgrandtotal, sethgrandtotal] = useState("");
  const [cashsalepopup, setcashsalepopup] = useState(false);
  const [listofCashSales, setlistofCashSales] = useState([]);
  const [listofCashSales1, setlistofCashSales1] = useState([]);
  const [CashSaleHistoric, setCashSaleHistoric] = useState(false);
  const [vatperc, setvatperc] = useState(16);
  const [ShowTable, setShowTable] = useState(false);
  const [productcode, setProductCode] = useState("");
  const [totalquantity, setTotalQuantity] = useState("");
  // let totalquantity = null;
  // let totalhquantity = null;
  const [totalhquantity, setTotalHQuantity] = useState("");
  const [grandtotal, setGrandTotal] = useState("");
  // let grandtotal = null;
  const [totalvat, setTotalVat] = useState("");
  // let totalvat = null;
  const [totallevy, setTotalLevy] = useState("");
  // let totallevy = null;
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [currentTime, setCurrentTime] = useState("");
  const [isloading, setisloading] = useState(true);
  const [mobileno, setmobileno] = useState(null);
  const [amountpaid, setamountpaid] = useState(null);
  const [showitems, setshowitems] = useState(false);
  const [search, setSearch] = useState("");
  const currentDate = new Date();
  const startOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1,
  );
  const localStartOfMonth = new Date(
    startOfMonth.getTime() - startOfMonth.getTimezoneOffset() * 60000,
  );

  const [startdate, setstartdate] = useState(localStartOfMonth.toISOString());
  const [enddate, setEnddate] = useState(currentDate.toISOString());
  const [searchprod, setSearchprod] = useState("");
  const [vatregno, setvatregno] = useState("");
  const [pinno, setpinno] = useState("");
  const [orgname, setorgname] = useState("");
  const [adress1, setadress1] = useState("");
  const [adress2, setadress2] = useState("");
  const [adress3, setadress3] = useState("");
  const [city, setcity] = useState("");
  const [country, setcountry] = useState("");
  const [compCode, setcompCode] = useState("");
  const [firstcashposno, setfirstcashposno] = useState("");
  const [latestcashposno, setlatestcashposno] = useState("");
  const location = useLocation();
  const clientNameOT = location?.state?.client;
  const clientCodeOT = location?.state?.clientCode;
  // let totalQtyOT = null;
  // let grandtotalOT = null;
  const [totalQtyOT, setTotalQtyOT] = useState("");
  const [totalLevyOT, setTotalLevyOT] = useState("");
  const [totalVatOT, setTotalVatOT] = useState("");
  const [grandtotalOT, setGranTotalOT] = useState("");
  const isOrderTakerValue = useRef(false);
  const [orderno, setOrderNo] = useState("");
  const [userdivisionRights, setuserDivisionList] = useState([]);

  const [listofClients, setlistofClients] = useState([]);
  const [selclientname, setselclientname] = useState("");
  const [clientcode, setclientcode] = useState("");
  const [clientCurrency, setClientCurrency] = useState("");
  const [clientExchRate, setClientExchRate] = useState("");
  const [outstandingamt, setoutstandingamt] = useState("");

  const [pdfData, setPdfData] = useState(null);
  const [LoadingScreenBlock, setLoadingScreenBlock] = useState(false);
  const [hist, setHist] = useState(false);
  const [reportName, setReportName] = useState("");
  const [reportPath, setReportPath] = useState("");

  const [allTablesList, setAllTablesList] = useState([]);
  const [areaList, setAreaList] = useState([]);
  const [selAreaName, setSelAreaName] = useState("");
  const [selAreaId, setSelAreaId] = useState("");
  const [catList, setCatList] = useState([]);
  const [subCatList, setSubCatList] = useState([]);
  const [prodList, setProdList] = useState([]);
  const [allProdsList, setAllProdsList] = useState([]);
  const [table, setistable] = useState(true);

  const [category, setcategory] = useState([]);
  const [itemdetails, setItemdetails] = useState([]);
  const [selcategory, setselcategory] = useState("");
  const [selSubCategory, setSelSubCategory] = useState("");
  const [acompanionList, setAccompanionList] = useState([]);
  const [auxiliaryList, setAuxiliaryList] = useState([]);
  const [fullacompanionList, setFullAccompanionList] = useState([]);
  const [fullauxiliaryList, setFullAuxiliaryList] = useState([]);

  const [showAcompanionItem, setShowAccompanionItem] = useState(false);
  const [showAuxiliaryItem, setShowAuxiliaryItem] = useState(false);
  const [showArea, setShowArea] = useState(false);
  const [showTableSelect, setShowTableSelect] = useState(false);

  const [showReceipts, setShowReceipts] = useState(false);
  const [cashPo, setCashPo] = useState("");

  const [showBillChargeOptions, setShowBillChargeOptions] = useState(false);
  const [selBillCharge, setSelBillCharge] = useState("");
  const [company, setCompany] = useState({});
  const [PopUpReport, setPopUpReport] = useState(false);

  const [showBillActions, setShowBillActions] = useState(false);
  const [showCancel, setShowCancel] = useState(false);
  const [showCreditClient, setShowCreditClient] = useState(false);
  const [cancelReasonList, setCancelReasonList] = useState([]);
  const [selReason, setSelReason] = useState("");
  const [selClientForCredit, setSelClientForCredit] = useState("");
  const [clientListForCredit, setClientListForCredit] = useState([]);

  const [showSales, setShowSales] = useState(false);

  const [createdBy, setCreatedBy] = useState("");
  const [createdDate, setCreatedDate] = useState("");
  const [approved, setApproved] = useState(false);
  const [approvedBy, setApprovedBy] = useState("");
  const [approvedDate, setApprovedDate] = useState("");
  const [cancelled, setCancelled] = useState(false);
  const [cancelledBy, setCancelledBy] = useState("");
  const [cancelledDate, setCancelledDate] = useState("");

  const [narration, setNarration] = useState("")
  
  const [showMergeBills, setShowMergeBills] = useState(false)
  const [showSplitBills,setShowSplitBills] = useState(false)

  useEffect(() => {
    let totalQtyOT = 0;
    let grandtotalOT = 0;
    let totalLevyOT = 0;
    let totalVatOT = 0;

    itemsListFromTakeOrder?.forEach((item) => {
      totalQtyOT += parseFloat(item.QTY);
      totalVatOT += parseFloat(item?.["VAT AMOUNT"]);
      totalLevyOT += parseFloat(item?.["LEVY AMOUNT"]);
      grandtotalOT += parseFloat(item.QTY) * parseFloat(item["ITEM VALUE"]);
    });

    setGranTotalOT(grandtotalOT);
    setTotalQtyOT(totalQtyOT);
    setTotalLevyOT(totalLevyOT);
    setTotalVatOT(totalVatOT);
  }, [itemsListFromTakeOrder]);

  useEffect(() => {
    axios
      .get(`${BASEURL}/getdivisionRights?OM_USER_ACCOUNT=${email}`)
      .then((response) => {
        setuserDivisionList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleOptionSelect = (option) => {
    setSeatingFlag(option);
  };

  const filtHistoricCash = listofCashSales1.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);
    const sDate = item.INVDATE;
    const eDate = item.INVDATE;

    if (searchData.length === 0 && !startdate && !enddate) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return ["INVNO", "SALES LOC", "CUSTOMER NAME", "FINANCIAL YEAR"].some(
        (key) => {
          const columnValue = String(item[key]).toLowerCase();
          return columnValue.includes(term);
        },
      );
    });

    const dateMatch =
      (!startdate || sDate >= startdate) && (!enddate || eDate <= enddate);

    return textMatch && dateMatch;
  });

  const filtProducts = listofProducts.filter((item) => {
    const searchData = searchprod.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return ["OM_ITEM_CODE", "OM_ITEM_DESCRIPTION", "STOCKQTY", "UOM"].some(
        (key) => {
          const columnValue = String(item[key]).toLowerCase();
          return columnValue.includes(term);
        },
      );
    });

    return textMatch;
  });

  const customStyless = {
    control: (baseStyles, state) => ({
      ...baseStyles,

      marginTop: "0px",
      minHeight: "initial",
      height: "31px",
      border: "1px solid",
      paddingBottom: "0px",
      paddingTop: "0px",
      marginLeft: "0px",
      backgroundColor: "white",
      color: "black",
      textTransform: "uppercase",
      "@media (max-width: 720px)": {
        minWidth: "181px",
      },
    }),
  };

  useEffect(() => {
    getALLData();
    const updateCurrentTime = () => {
      const currentDate = new Date();
      const formattedTime = currentDate.toLocaleTimeString();
      setCurrentTime(formattedTime);
    };

    updateCurrentTime();
    const intervalId = setInterval(updateCurrentTime, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const getALLData = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=602`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => setCompany(res?.data[0]))
      .catch((err) => {
        setisloading(false);
        console.log("Error While fetching Driver List", err);
      });

    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=531&DIVISION=${divisionState}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((response) => {
        setAllTablesList(response?.data);
        const uniqueAreas = [
          ...new Map(
            response.data.map((item) => [item.AREANAME, item]),
          ).values(),
        ];
        console.log(uniqueAreas);
        setAreaList(uniqueAreas);
      })
      .catch((error) => {
        console.error("Error fetching Table details:", error);
      });

    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=686&CREATED DIVISON CODE=${divisionState}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((response) => {
        console.log(response.data);
        setlistofCashSales(response?.data);
        setlistofCashSales1(response?.data);
        setfirstcashposno(response?.data[0]?.INVNO);
      })
      .catch((error) => {
        console.error("Error fetching List Of Cash Sale History:", error);
        setisloading(false);
      });

    // getNewCashPOSNo
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=466`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setnewCashPOSNo(response.data[0].INVNO);
        setlatestcashposno(response.data[0].INVNO);
        if (ordernoToPass) {
          fetchAllDetails(ordernoToPass);
        }
      })
      .catch((error) => {
        console.error("Error fetching New Cash POS Number:", error);
      });

    // getListOfServedBy
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=560`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setlistofservers(response.data);
      })
      .catch((error) => {
        console.error("Error fetching List Of Served By:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=28`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setClientListForCredit(response.data);
        const filterData = response?.data?.filter(
          (item) => item?.CASHCREDIT === "CASH",
        );
        setlistofClients(filterData);
        const clientBasedOnDiv = filterData?.find(
          (item) => item?.CATEGORY === division && item?.CASHCREDIT === "CASH",
        );
        console.log(clientBasedOnDiv);
        if (clientBasedOnDiv) {
          setselclientname(clientBasedOnDiv?.CLIENTNAME);
          setclientcode(clientBasedOnDiv?.CLIENTCODE);
        }
      })
      .catch((error) => {
        console.error("Error fetching List Of Clients:", error);
      });

    // getProductDetails
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=287`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setListOfProducts(response.data);
      })
      .catch((error) => {
        console.error("Error fetching List Of Products:", error);
      });

    // getCompanyDetails
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=40`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setcompCode(response.data[0].ORGCODE);
        setvatregno(response.data[0].ORG_VAT_REG_NO);
        setpinno(response.data[0].ORG_PIN_NO);
        setorgname(response.data[0].ORG_NAME);
        setadress1(response.data[0].ORG_ADDRESS_1);
        setadress2(response.data[0].ORG_ADDRESS_2);
        setadress3(response.data[0].ORG_ADDRESS_3);
        setcity(response.data[0].ORG_CITY);
        setcountry(response.data[0].ORG_COUNTRY);
      })
      .catch((error) => {
        console.error("Error fetching List Of Cash Sale History:", error);
      });

    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=287&FINISHEDRAWMATERIAL=F&DEPARTMENT=${division}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((response) => {
        setAllProdsList(response?.data);
        const uniqueCat = [
          ...new Map(
            response.data.map((item) => [item.MAINCATEGORY, item]),
          ).values(),
        ];
        setCatList(uniqueCat);
        setistable(false);
      })
      .catch((error) => {
        console.error("Error fetching Main Categories:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1685`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setFullAccompanionList(response?.data);
      })
      .catch((error) => {
        console.error("Error fetching 1685:", error);
      });
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1686`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        console.log(response?.data);
        setFullAuxiliaryList(response?.data);
      })
      .catch((error) => {
        console.error("Error fetching 1686:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1747`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        setCancelReasonList(res?.data);
        setisloading(false);
      })
      .catch((err) => {
        setisloading(false);
        console.log("Error While fetching 1747", err);
      });
  };

  const generateInvoicePDF = () => {
    const doc = new jsPDF();
    let yPos = 10;
    doc.setFontSize(20);
    doc.text(orgname ? orgname : "", 105, yPos, { align: "center" });
    yPos += 10;
    doc.setFontSize(15);
    doc.text("Tel : 0710237671", 105, yPos, { align: "center" });
    yPos += 10;
    doc.setFontSize(15);
    doc.text(adress1 ? adress1 : "", 40, yPos);
    doc.text(",", 64, yPos);
    doc.text(adress2 ? adress2 : "", 65, yPos);
    doc.text(",", 89, yPos);
    doc.text(adress3 ? adress3 : "", 90, yPos);
    doc.text(",", 104, yPos);
    doc.text(city ? city : "", 105, yPos);
    doc.text(",", 129, yPos);
    doc.text(country ? country : "", 130, yPos);
    yPos += 10;
    doc.setFontSize(13);
    doc.text("BRANCH : ", 20, yPos);
    doc.text("TWO RIVERS", 50, yPos);
    doc.text("VAT REG NO : ", 100, yPos);
    doc.text(vatregno ? vatregno.toString() : "", 140, yPos);
    yPos += 7;
    doc.text("PIN NO : ", 20, yPos);
    doc.text(pinno ? pinno.toString() : "", 50, yPos);
    yPos += 7;
    doc.text("BILL NO : ", 20, yPos);
    doc.text(newCashPOSNo.toString(), 50, yPos);
    doc.text("BILL DATE : ", 100, yPos);
    doc.text(date ? moment(date).format("DD/MM/YYYY") : "", 140, yPos);
    // Draw a horizontal line after the header
    yPos += 10;
    doc.setFontSize(20);
    doc.text("BILL", 90, yPos);

    yPos += 5;
    doc.setLineWidth(0.5);
    doc.line(20, yPos, 190, yPos);

    yPos += 10;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);

    // Headers for service name and amount
    doc.text("ITEM NAME", 20, yPos);
    doc.text("QUANTITY", 100, yPos);
    doc.text("PRICE", 135, yPos);
    doc.text("AMOUNT", 160, yPos);

    yPos += 5;
    doc.setLineWidth(0.5);
    doc.setLineDash([1, 2]); // Set a dotted pattern
    doc.line(20, yPos, 190, yPos);
    yPos += 5;

    let totalAmount = 0;
    itemsListFromTakeOrder.forEach((item, index) => {
      yPos += 5;
      // Adjusted widths for columns
      const productNameWidth = 80;
      // Wrap the ProductName within the allocated space
      const wrappedProductName = doc.splitTextToSize(
        item.ProductName,
        productNameWidth,
      );
      // Draw each column
      doc.text(wrappedProductName, 20, yPos);
      doc.text(item.quanity.toString(), 115, yPos);
      doc.text(item.rate.toString(), 140, yPos);
      doc.text(item.totalamount.toString(), 170, yPos);
      // Determine the maximum height among the columns for the current row
      const maxColumnHeight = Math.max(
        doc.getTextDimensions(wrappedProductName).h,
        doc.getTextDimensions(item.quanity.toString()).h,
        doc.getTextDimensions(item.rate.toString()).h,
        doc.getTextDimensions(item.totalamount.toString()).h,
      );
      // Draw a dotted line after each item for separation
      yPos += maxColumnHeight + 5;
      doc.setLineWidth(0.5);
      doc.setLineDash([1, 2]); // Set a dotted pattern
      doc.line(20, yPos, 190, yPos);
      yPos += 5;
      const numericAmount = parseFloat(item.totalamount);
      totalAmount += numericAmount;
    });

    doc.setFontSize(15);
    yPos += 5;
    doc.text("Total Amount:", 130, yPos);
    doc.text(`${totalAmount.toFixed(2)}`, 170, yPos);
    yPos += 10;
    doc.setLineWidth(0.5);
    doc.setLineDash([1, 2]); // Set a dotted pattern
    doc.line(20, yPos, 190, yPos);
    yPos += 10;
    doc.text("This is not an official Receipt", 20, yPos);
    yPos += 10;
    doc.text(
      "Please Insist on the official Receipt after paying the bill",
      20,
      yPos,
    );
    yPos += 10;
    doc.setLineWidth(0.5);
    doc.setLineDash([1, 2]); // Set a dotted pattern
    doc.line(20, yPos, 190, yPos);
    yPos += 10;
    doc.text("You Were Served by :", 20, yPos);
    doc.text(selservername ? selservername : "", 80, yPos);
    yPos += 10;
    doc.setLineWidth(0.5);
    doc.setLineDash([1, 2]); // Set a dotted pattern
    doc.line(20, yPos, 190, yPos);
    yPos += 10;
    doc.text("Mars Track ERP www.gbsafrica.net", 20, yPos);
    yPos += 10;
    doc.text("Powered by Genius Buisness System", 20, yPos);

    doc.save("CashSaleInvoice.pdf");
  };

  function handleReceipt(cashsaleno, total, vat, levy) {
    navigate("/Receipt", { state: { cashsaleno, total, vat, levy } });
  }

  const getNewCashPosNo = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=466`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setnewCashPOSNo(response.data[0].INVNO);
        setlatestcashposno(response.data[0].INVNO);
      })
      .catch((error) => {
        console.error("Error fetching New Cash POS Number:", error);
      });
  };

  useEffect(() => {
    if (listofClients?.length > 0 && selclientname) {
      handlleClientDetails(selclientname);
    }
  }, [listofClients]);

  const handlleClientDetails = (e) => {
    const selected = listofClients.find((obj) => obj.CLIENTNAME === e);
    if (selected) {
      setclientcode(selected.CLIENTCODE);
      setClientCurrency(selected.CURRENCY);
      setoutstandingamt(selected.CREDITLIMIT);
      axios
        .get(
          `${BASEURL_GLOBAL}/globalViewHandler?viewname=1276&CURRENCYCODE=${selected.CURRENCY}`,
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessiontoken,
            },
          },
        )
        .then((res) => {
          setClientExchRate(res?.data?.[0]?.EXCHRATE);
        })
        .catch((err) => {
          setisloading(false);
          console.log("Error While fetching 1277", err);
        });
    }
  };

  // useEffect(() => {
  //   if (ordernoToPass && newCashPOSNo) {
  //     fetchAllDetails(ordernoToPass);
  //   }
  // }, [ordernoToPass,newCashPOSNo]);

  const fetchAllDetails = (cashposno) => {
    setisloading(true);
    setShowTable(true);
    setCashSaleHistoric(true);
    setPdfData(null);
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=624&INVNO=${cashposno}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((response) => {
        console.log(response?.data[0]);
        setlistofCashSales(response.data);
        setnewCashPOSNo(response.data[0].INVNO);
        setDate(response.data[0].INVDATE);
        setvatperc(16);
        setvatamt(response.data[0]["VAT AMT"]);
        setlevyamt(response.data[0]["LEVY AMT"]);
        setlevyperc(response.data[0]["LEVY PERC"]);
        setGranTotalOT(response.data[0]["AMOUNT INCLUSIVE VAT"]);
        setselservername(response.data[0].WAITER);
        setselclientname(response.data[0]["CUSTOMER NAME"]);
        setclientcode(response.data[0]["CUSTOMER CODE"]);
        setClientCurrency(response?.data[0]?.CURRENCYCODE);
        setClientExchRate(response?.data[0]?.CONVRATE);
        setseltable(response.data[0].TABLENO);
        setSelAreaName(response.data[0].AREA);
        setNarration(response.data[0].NARRATION);
        setCreatedDate(response.data[0]?.["CREATED DATE"]);
        setCreatedBy(response.data[0]?.["CREATED BY"]);
        setCancelled(response.data[0].CANCELLED);
        setCancelledBy(response.data[0].CANCELLEDBY);
        setCancelledDate(response.data[0].CANCELLEDDATE);
        const area = areaList?.find(
          (item) => item?.AREANAME === response?.data[0]?.AREA,
        );
        setSelAreaId(area?.AREAID);

        setmobileno(response.data[0].MOBILENO);
        if (response.data[0].SEATINGDELIVERY) {
          if (response.data[0].SEATINGDELIVERY == "SEATING") {
            handleOptionSelect(1);
          } else {
            handleOptionSelect(2);
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching List Of Cash Sale History:", error);
      });

    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=622&INVNO=${cashposno}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((response) => {
        setItemListFromTakeOrder(response.data);
        setisloading(false);
      })
      .catch((error) => {
        console.error("Error fetching Cash Sale History Details:", error);
      });
  };

  const handleButtonClick = async (operation) => {
    try {
      // const latestPOSNo = await getLatestPOSNo();

      if (operation === "decrement" && newCashPOSNo > firstcashposno) {
        setselProductname("");
        setProductCode("");
        setQuantity("");
        setvatamt("");
        setlevyamt("");
        setRate("");
        setlevyflag(false);
        setvatflag(false);
        setnewCashPOSNo(newCashPOSNo - 1);
        fetchAllDetails(newCashPOSNo - 1);
      } else if (operation === "increment" && newCashPOSNo < latestcashposno) {
        setselProductname("");
        setProductCode("");
        setQuantity("");
        setvatamt("");
        setlevyamt("");
        setRate("");
        setlevyflag(false);
        setvatflag(false);
        setnewCashPOSNo(newCashPOSNo + 1);
        fetchAllDetails(newCashPOSNo + 1);
      } else if (operation === "first") {
        setselProductname("");
        setProductCode("");
        setQuantity("");
        setvatamt("");
        setlevyamt("");
        setRate("");
        setlevyflag(false);
        setvatflag(false);
        setnewCashPOSNo(firstcashposno);
        fetchAllDetails(firstcashposno);
      } else if (operation === "latest") {
        setselProductname("");
        setProductCode("");
        setQuantity("");
        setvatamt("");
        setlevyamt("");
        setRate("");
        setlevyflag(false);
        setvatflag(false);
        setnewCashPOSNo(latestcashposno - 1);
        fetchAllDetails(latestcashposno - 1);
      }
    } catch (error) {
      console.error("Error handling button click:", error);
    }
  };

  const getLatestPOSNo = async () => {
    try {
      // const response = await axios.get(`${BASEURL}/newCashPosNo`, {
      const response = await axios.get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=466`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      );

      return response.data[0].INVNO;
    } catch (error) {
      console.error("Error fetching New Cash POS Number:", error);
    }
  };

  // Adding into Tables *********************************************************************************
  // const AddCostItem = () => {
  //   if (!selProductname) {
  //     alert("Please select Product first ,Click on Search Button to Choose");
  //   } else if (Number(Quantity) <= 0) {
  //     alert("Quantity Can not be empty ,negative or 0");
  //     setQuantity("");
  //   } else {
  //     const newItem = {
  //       ["ITEM CODE"]: productcode,
  //       ["ITEM NAME"]: selProductname,
  //       QTY: Number(Quantity),
  //       ["ITEM RATE"]:
  //         Number(Rate) * Number(Quantity) - (Number(vatamt) + Number(levyamt)),
  //       ["ITEM VALUE"]: Number(Rate),
  //       // POITEMAMOUNT: Number(Rate) * Number(Quantity),
  //       ["VAT AMOUNT"]: Number(vatamt),
  //       ["LEVY AMOUNT"]: Number(levyamt),
  //     };

  //     const existingRowIndex = itemsListFromTakeOrder.findIndex(
  //       (item) =>
  //         item?.["ITEM CODE"] === newItem?.["ITEM CODE"] &&
  //         item?.["ITEM NAME"] === newItem?.["ITEM NAME"],
  //     );

  //     if (existingRowIndex !== -1) {
  //       const updatedItems = [...itemsListFromTakeOrder];
  //       updatedItems[existingRowIndex] = newItem;
  //       setItemListFromTakeOrder(updatedItems);
  //     } else {
  //       setItemListFromTakeOrder([...itemsListFromTakeOrder, newItem]);
  //     }

  //     setvatperc(16);
  //     setlevyperc(2);
  //     setShowTable(true);
  //     clearallinputs();
  //   }
  // };

  // const RemoveItems = () => {
  //   const updatedValues = [...itemsListFromTakeOrder];
  //   if (updatedValues.length === 0) {
  //     alert("There is no Items to be removed");
  //     setShowTable(false);
  //   } else {
  //     if (
  //       selectedRowIndex !== null &&
  //       selectedRowIndex >= 0 &&
  //       selectedRowIndex < updatedValues.length
  //     ) {
  //       updatedValues.splice(selectedRowIndex, 1);
  //       setSelectedRowIndex(null);
  //     } else {
  //       updatedValues.pop();
  //     }
  //     setItemListFromTakeOrder(updatedValues);
  //     if (updatedValues.length === 0) {
  //       setShowTable(false);
  //       setvatperc("");
  //       setlevyperc("");
  //     }
  //   }
  // };

  // const clearallinputs = () => {
  //   setselProductname("");
  //   setQuantity("");
  //   setRate("");
  //   setlevyamt("");
  //   setlevyflag(false);
  //   setvatamt("");
  //   setvatflag(false);
  // };

  const AddCostItem = () => {
    if (!selProductname) {
      alert("Please select Product first ,Click on Search Button to Choose");
    } else if (Number(Quantity) <= 0) {
      alert("Quantity Can not be empty ,negative or 0");
      setQuantity("");
    } else {
      // UPDATED — manually-added cost items are standalone (top-level) rows,
      // never accompaniment/auxiliary, so tag them explicitly and give them
      // a rowId like every other row in itemsListFromTakeOrder
      const newItem = {
        ["ITEM CODE"]: productcode,
        ["ITEM NAME"]: selProductname,
        QTY: Number(Quantity),
        ["ITEM RATE"]:
          Number(Rate) * Number(Quantity) - (Number(vatamt) + Number(levyamt)),
        ["ITEM VALUE"]: Number(Rate),
        ["VAT AMOUNT"]: Number(vatamt),
        ["LEVY AMOUNT"]: Number(levyamt),
        PARENT_ITEM_CODE: null, // NEW — explicit standalone marker
        ADDON_TYPE: null, // NEW
      };

      // UPDATED — only match against OTHER standalone rows (PARENT_ITEM_CODE
      // null). Without this guard, editing a cost item with the same code as
      // an existing accompaniment/auxiliary row would overwrite that child row.
      const existingRowIndex = itemsListFromTakeOrder.findIndex(
        (item) =>
          item?.["ITEM CODE"] === newItem?.["ITEM CODE"] &&
          item?.["ITEM NAME"] === newItem?.["ITEM NAME"] &&
          !item?.PARENT_ITEM_CODE,
      );

      if (existingRowIndex !== -1) {
        const updatedItems = [...itemsListFromTakeOrder];
        // UPDATED — preserve the existing rowId instead of losing it,
        // so any add-ons already linked to this row stay linked
        updatedItems[existingRowIndex] = {
          ...newItem,
          rowId: updatedItems[existingRowIndex].rowId,
        };
        setItemListFromTakeOrder(updatedItems);
      } else {
        setItemListFromTakeOrder([
          ...itemsListFromTakeOrder,
          { ...newItem, rowId: generateRowId() },
        ]);
      }

      setvatperc(16);
      setlevyperc(2);
      setShowTable(true);
      clearallinputs();
    }
  };

  // UPDATED — now removes by rowId instead of array index, and cascades:
  // removing a parent also removes every accompaniment/auxiliary row linked
  // to it, so quantities/tallies never go stale
  // const RemoveItems = (rowId = null) => {
  //   const updatedValues = [...itemsListFromTakeOrder];

  //   if (updatedValues.length === 0) {
  //     alert("There is no Items to be removed");
  //     setShowTable(false);
  //     return;
  //   }

  //   // Resolve the row to remove: explicit rowId param, else the currently
  //   // selected row, else fall back to the last row (old .pop() behavior)
  //   const targetRowId =
  //     rowId ??
  //     (selectedRowIndex !== null
  //       ? updatedValues[selectedRowIndex]?.rowId
  //       : null) ??
  //     updatedValues[updatedValues.length - 1]?.rowId;

  //   const targetRow = updatedValues.find((row) => row.rowId === targetRowId);

  //   if (!targetRow) {
  //     setSelectedRowIndex(null);
  //     return;
  //   }

  //   let filteredValues;

  //   if (!targetRow.PARENT_ITEM_CODE) {
  //     // Removing a PARENT row — also remove all its accompaniment/auxiliary
  //     // children so nothing is left pointing at a deleted parent
  //     filteredValues = updatedValues.filter(
  //       (row) =>
  //         row.rowId !== targetRow.rowId &&
  //         row.PARENT_ITEM_CODE !== targetRow["ITEM CODE"],
  //     );
  //   } else {
  //     // Removing a single accompaniment/auxiliary CHILD row only
  //     filteredValues = updatedValues.filter(
  //       (row) => row.rowId !== targetRow.rowId,
  //     );
  //   }

  //   setSelectedRowIndex(null);
  //   setItemListFromTakeOrder(filteredValues);

  //   if (filteredValues.length === 0) {
  //     setShowTable(false);
  //     setvatperc("");
  //     setlevyperc("");
  //   }
  // };

  const RemoveItems = () => {
  const updatedValues = [...itemsListFromTakeOrder];

  if (updatedValues.length === 0) {
    alert("There is no Items to be removed");
    setShowTable(false);
    return;
  }

  // Remove only the row selected by selectedRowIndex
  if (
    selectedRowIndex === null ||
    selectedRowIndex < 0 ||
    selectedRowIndex >= updatedValues.length
  ) {
    return;
  }

    const targetRow = updatedValues[selectedRowIndex];
    
  if (targetRow?.SENTTOKITCHEN === true && targetRow?.INVNO === newCashPOSNo && targetRow?.["ITEM CODE"] === productcode) {
      alert("This Product is sent to kitchen , can not remove")
      return;
    }
    
  let filteredValues;

  if (!targetRow.PARENT_ITEM_CODE) {
    // Removing a PARENT row — also remove its accompaniment/auxiliary children
    filteredValues = updatedValues.filter(
      (row) =>
        row.rowId !== targetRow.rowId &&
        row.PARENT_ITEM_CODE !== targetRow["ITEM CODE"]
    );
  } else {
    // Removing only the selected CHILD row
    filteredValues = updatedValues.filter(
      (row) => row.rowId !== targetRow.rowId
    );
  }

    setRate("")
    setselProductname("")
    setProductCode("");
    setQuantity("")
    
  setSelectedRowIndex(null);
  setItemListFromTakeOrder(filteredValues);

  if (filteredValues.length === 0) {
    setShowTable(false);
    setvatperc("");
    setlevyperc("");
  }
};

  const clearallinputs = () => {
    setselProductname("");
    setProductCode("");
    setQuantity("");
    setRate("");
    setlevyamt("");
    setlevyflag(false);
    setvatamt("");
    setvatflag(false);
  };

  // ******************************* POP Up *************************************************
  const handleSearchClick = () => {
    // Open the popup window
    setPopupOpen(true);
  };

  const handleRowClick = (row) => {
    setActualQuantity(row.STOCKQTY);
    setSelectedRow(row);
    setQuantity(1);
    setRate(row.SELLINGPRICE);
    setProductCode(row.OM_ITEM_CODE);
    setselProductname(row.OM_ITEM_DESCRIPTION);
    setlevyflag(row.LEVYAPPLICABLE == 1 ? true : false);
    setvatflag(row.VATABLE == 1 ? true : false);
    if (row.LEVYAPPLICABLE == 1 && row.VATABLE == 1) {
      setlevyamt(((row.SELLINGPRICE * 1) / 118) * 2);
      setvatamt(row.SELLINGPRICE - row.SELLINGPRICE / 1.16);
    } else if (row.LEVYAPPLICABLE == 1 && row.VATABLE == 0) {
      setlevyamt(((row.SELLINGPRICE * 1) / 102) * 2);
      setvatamt(0);
    } else if (row.LEVYAPPLICABLE == 0 && row.VATABLE == 1) {
      setlevyamt(0);
      setvatamt(row.SELLINGPRICE - row.SELLINGPRICE / 1.16);
    } else if (row.LEVYAPPLICABLE == 0 && row.VATABLE == 0) {
      setlevyamt(0);
      setvatamt(0);
    }

    setPopupOpen(false);
  };

  const [selectedParentItem, setSelectedParentItem] = useState(null);

  const generateRowId = () =>
    `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 9)}`;

  // const handleRowClickItem = (item, parentItem = null) => {
  //   setvatperc(16);
  //   setlevyperc(2);
  //   setItemListFromTakeOrder((prevItems) => {
  //     let updatedItems = [...prevItems];

  //     // -------------------------
  //     // Add Parent Item (Only Once)
  //     // -------------------------
  //     if (parentItem) {
  //       const parentExists = updatedItems.some(
  //         (selected) =>
  //           selected["ITEM CODE"] === parentItem.OM_ITEM_CODE &&
  //           selected["ITEM NAME"] === parentItem.OM_ITEM_DESCRIPTION,
  //       );

  //       if (!parentExists) {
  //         updatedItems.push({
  //           ...parentItem,
  //           rowId: generateRowId(),
  //           ["ITEM CODE"]: parentItem.OM_ITEM_CODE,
  //           ["ITEM NAME"]: parentItem.OM_ITEM_DESCRIPTION,
  //           QTY: 1,
  //           ["ITEM VALUE"]: parentItem.SELLINGPRICE,
  //           ["ITEM RATE"]: parentItem.RATEEXCLUSIVE,
  //           ["VAT AMOUNT"]: parentItem.VATAMT,
  //           ["LEVY AMOUNT"]: parentItem.LEVYAMT,
  //         });
  //       }

  //       updatedItems.push({
  //         ...item,
  //         rowId: generateRowId(), // NEW — makes this row unique
  //         ["ITEM CODE"]: item.OM_ITEM_CODE,
  //         ["ITEM NAME"]: item.OM_ITEM_DESCRIPTION,
  //         QTY: 1,
  //         ["ITEM VALUE"]: 0,
  //         ["ITEM RATE"]: 0,
  //         ["VAT AMOUNT"]: 0,
  //         ["LEVY AMOUNT"]: 0,
  //         PARENT_ITEM_CODE: parentItem.OM_ITEM_CODE,
  //         PARENT_ITEM_NAME: parentItem.OM_ITEM_DESCRIPTION,
  //       });
  //       return updatedItems;
  //     }

  //     // -------------------------
  //     // Selected Item
  //     // -------------------------
  //     const exists = updatedItems.some(
  //       (selected) =>
  //         selected["ITEM CODE"] === item.OM_ITEM_CODE &&
  //         selected["ITEM NAME"] === item.OM_ITEM_DESCRIPTION,
  //     );

  //     if (exists) {
  //       return updatedItems.filter(
  //         (selected) =>
  //           selected["ITEM CODE"] !== item.OM_ITEM_CODE ||
  //           selected["ITEM NAME"] !== item.OM_ITEM_DESCRIPTION,
  //       );
  //     }

  //     updatedItems.push({
  //       ...item,
  //       rowId: generateRowId(),
  //       ["ITEM CODE"]: item.OM_ITEM_CODE,
  //       ["ITEM NAME"]: item.OM_ITEM_DESCRIPTION,
  //       QTY: 1,
  //       ["ITEM VALUE"]: parentItem ? 0 : item.SELLINGPRICE,
  //       ["ITEM RATE"]: parentItem ? 0 : item.RATEEXCLUSIVE,
  //       ["VAT AMOUNT"]: parentItem ? 0 : item.VATAMT,
  //       ["LEVY AMOUNT"]: parentItem ? 0 : item.LEVYAMT,
  //     });

  //     return updatedItems;
  //   });

  //   setShowTable(true);
  // };

  // NEW
  // const handleRowClickItem = (item, parentItem = null) => {
  //   setvatperc(16);
  //   setlevyperc(2);

  //   // -------------------------
  //   // NEW — Tally check: block adding this accompaniment/auxiliary if
  //   // it would push the total past the parent's qty
  //   // -------------------------
  //   if (parentItem) {
  //     const parentRow = getParentRow(parentItem);
  //     const parentQty = parentRow?.QTY || 0;
  //     const childQtyTotal = getChildQtyTotal(parentItem.OM_ITEM_CODE);

  //     if (childQtyTotal >= parentQty) {
  //       alert(
  //         `You can only add ${parentQty} accompaniment/auxiliary item(s) for this quantity. Increase the item's quantity to add more.`,
  //       );
  //       return; // stop — do not add
  //     }
  //   }

  //   setItemListFromTakeOrder((prevItems) => {
  //     let updatedItems = [...prevItems];

  //     if (parentItem) {
  //       // UPDATED — parent is no longer pushed here; it's already in the
  //       // cart via addParentItem (called when the tile was first clicked).
  //       // Only the child row gets pushed.
  //       updatedItems.push({
  //         ...item,
  //         rowId: generateRowId(),
  //         ["ITEM CODE"]: item.OM_ITEM_CODE,
  //         ["ITEM NAME"]: item.OM_ITEM_DESCRIPTION,
  //         QTY: 1,
  //         ["ITEM VALUE"]: 0,
  //         ["ITEM RATE"]: 0,
  //         ["VAT AMOUNT"]: 0,
  //         ["LEVY AMOUNT"]: 0,
  //         PARENT_ITEM_CODE: parentItem.OM_ITEM_CODE,
  //         PARENT_ITEM_NAME: parentItem.OM_ITEM_DESCRIPTION,
  //       });
  //       return updatedItems;
  //     }

  //     // Standalone item — unchanged dedupe/toggle logic
  //     const exists = updatedItems.some(
  //       (selected) =>
  //         selected["ITEM CODE"] === item.OM_ITEM_CODE &&
  //         selected["ITEM NAME"] === item.OM_ITEM_DESCRIPTION,
  //     );

  //     if (exists) {
  //       return updatedItems.filter(
  //         (selected) =>
  //           selected["ITEM CODE"] !== item.OM_ITEM_CODE ||
  //           selected["ITEM NAME"] !== item.OM_ITEM_DESCRIPTION,
  //       );
  //     }

  //     updatedItems.push({
  //       ...item,
  //       rowId: generateRowId(),
  //       ["ITEM CODE"]: item.OM_ITEM_CODE,
  //       ["ITEM NAME"]: item.OM_ITEM_DESCRIPTION,
  //       QTY: 1,
  //       ["ITEM VALUE"]: item.SELLINGPRICE,
  //       ["ITEM RATE"]: item.RATEEXCLUSIVE,
  //       ["VAT AMOUNT"]: item.VATAMT,
  //       ["LEVY AMOUNT"]: item.LEVYAMT,
  //     });

  //     return updatedItems;
  //   });

  //   setShowTable(true);
  // };

  // const updateItemQty = (rowId, type) => {
  //   setItemListFromTakeOrder((prevItems) => {
  //     return prevItems
  //       .map((selected) => {
  //         if (selected.rowId === rowId) {
  //           const qty =
  //             type === "inc" ? selected.QTY + 1 : Math.max(selected.QTY - 1, 0);

  //           return {
  //             ...selected,
  //             QTY: qty,
  //             ["VAT AMOUNT"]: qty * Number(selected?.["VAT AMOUNT"] || 0),
  //             ["LEVY AMOUNT"]: qty * Number(selected?.["LEVY AMOUNT"] || 0),
  //           };
  //         }

  //         return selected;
  //       })
  //       .filter((selected) => selected.QTY > 0);
  //   });
  // };

  // NEW
  // const updateItemQty = (rowId, type) => {
  //   setItemListFromTakeOrder((prevItems) => {
  //     const targetRow = prevItems.find((row) => row.rowId === rowId);
  //     if (!targetRow) return prevItems;

  //     // NEW — incrementing a CHILD row: can't exceed the parent's qty
  //     if (targetRow.PARENT_ITEM_CODE && type === "inc") {
  //       const parentRow = prevItems.find(
  //         (row) =>
  //           row["ITEM CODE"] === targetRow.PARENT_ITEM_CODE &&
  //           !row.PARENT_ITEM_CODE,
  //       );
  //       const parentQty = parentRow?.QTY || 0;
  //       const childQtyTotal = prevItems
  //         .filter((row) => row.PARENT_ITEM_CODE === targetRow.PARENT_ITEM_CODE)
  //         .reduce((sum, row) => sum + Number(row.QTY || 0), 0);

  //       if (childQtyTotal >= parentQty) {
  //         alert(
  //           `Accompaniment/auxiliary quantity cannot exceed this item's quantity (${parentQty}).`,
  //         );
  //         return prevItems;
  //       }
  //     }

  //     // NEW — decrementing a PARENT row: can't drop below what's already
  //     // allocated to its accompaniment/auxiliary rows
  //     if (!targetRow.PARENT_ITEM_CODE && type === "dec") {
  //       const childQtyTotal = prevItems
  //         .filter((row) => row.PARENT_ITEM_CODE === targetRow["ITEM CODE"])
  //         .reduce((sum, row) => sum + Number(row.QTY || 0), 0);
  //       const nextQty = Math.max(targetRow.QTY - 1, 0);

  //       if (nextQty < childQtyTotal) {
  //         alert(
  //           `Remove some accompaniment/auxiliary items first — they currently total ${childQtyTotal}.`,
  //         );
  //         return prevItems;
  //       }
  //     }

  //     return prevItems
  //       .map((selected) => {
  //         if (selected.rowId === rowId) {
  //           const qty =
  //             type === "inc" ? selected.QTY + 1 : Math.max(selected.QTY - 1, 0);

  //           return {
  //             ...selected,
  //             QTY: qty,
  //             ["VAT AMOUNT"]: qty * Number(selected?.["VAT AMOUNT"] || 0),
  //             ["LEVY AMOUNT"]: qty * Number(selected?.["LEVY AMOUNT"] || 0),
  //           };
  //         }
  //         return selected;
  //       })
  //       .filter((selected) => selected.QTY > 0);
  //   });
  // };

  // UPDATED — accepts addonType ("ACCOMPANIMENT" | "AUXILIARY") and tallies
  // against that type only, so each list gets its own allowance up to parent qty
  const handleRowClickItem = (item, parentItem = null, addonType = null) => {
    setvatperc(16);
    setlevyperc(2);

    if (parentItem) {
      const parentRow = getParentRow(parentItem);
      const parentQty = parentRow?.QTY || 0;
      const childQtyTotal = getChildQtyTotal(
        parentItem.OM_ITEM_CODE,
        addonType,
      );

      if (childQtyTotal >= parentQty) {
        alert(
          `You can only add ${parentQty} ${addonType === "AUXILIARY" ? "auxiliary" : "accompaniment"} item(s) for this quantity.`,
        );
        return;
      }
    }

    setItemListFromTakeOrder((prevItems) => {
      let updatedItems = [...prevItems];

      if (parentItem) {
        updatedItems.push({
          ...item,
          rowId: generateRowId(),
          ["ITEM CODE"]: item.OM_ITEM_CODE,
          ["ITEM NAME"]: item.OM_ITEM_DESCRIPTION,
          QTY: 1,
          ["ITEM VALUE"]: 0,
          ["ITEM RATE"]: 0,
          ["VAT AMOUNT"]: 0,
          ["LEVY AMOUNT"]: 0,
          PARENT_ITEM_CODE: parentItem.OM_ITEM_CODE,
          PARENT_ITEM_NAME: parentItem.OM_ITEM_DESCRIPTION,
          ADDON_TYPE: addonType, // NEW — tags the row as accompaniment or auxiliary
        });
        return updatedItems;
      }

      const exists = updatedItems.some(
        (selected) =>
          selected["ITEM CODE"] === item.OM_ITEM_CODE &&
          selected["ITEM NAME"] === item.OM_ITEM_DESCRIPTION,
      );

      if (exists) {
        return updatedItems.filter(
          (selected) =>
            selected["ITEM CODE"] !== item.OM_ITEM_CODE ||
            selected["ITEM NAME"] !== item.OM_ITEM_DESCRIPTION,
        );
      }

      updatedItems.push({
        ...item,
        rowId: generateRowId(),
        ["ITEM CODE"]: item.OM_ITEM_CODE,
        ["ITEM NAME"]: item.OM_ITEM_DESCRIPTION,
        QTY: 1,
        UOM: item.UOM,
        ["ITEM VALUE"]: item.SELLINGPRICE,
        ["ITEM RATE"]: item.RATEEXCLUSIVE,
        ["VAT AMOUNT"]: item.VATAMT,
        ["LEVY AMOUNT"]: item.LEVYAMT,
      });

      return updatedItems;
    });

    setShowTable(true);
  };

  // UPDATED — inc on a child checks its own type's tally; dec on a parent
  // checks against BOTH types' totals (neither can exceed the new qty)
  const updateItemQty = (rowId, type) => {
    setItemListFromTakeOrder((prevItems) => {
      const targetRow = prevItems.find((row) => row.rowId === rowId);
      if (!targetRow) return prevItems;

      if (targetRow.PARENT_ITEM_CODE && type === "inc") {
        const parentRow = prevItems.find(
          (row) =>
            row["ITEM CODE"] === targetRow.PARENT_ITEM_CODE &&
            !row.PARENT_ITEM_CODE,
        );
        const parentQty = parentRow?.QTY || 0;
        const childQtyTotal = prevItems
          .filter(
            (row) =>
              row.PARENT_ITEM_CODE === targetRow.PARENT_ITEM_CODE &&
              row.ADDON_TYPE === targetRow.ADDON_TYPE,
          )
          .reduce((sum, row) => sum + Number(row.QTY || 0), 0);

        if (childQtyTotal >= parentQty) {
          alert(
            `${targetRow.ADDON_TYPE === "AUXILIARY" ? "Auxiliary" : "Accompaniment"} quantity cannot exceed this item's quantity (${parentQty}).`,
          );
          return prevItems;
        }
      }

      if (!targetRow.PARENT_ITEM_CODE && type === "dec") {
        const accTotal = prevItems
          .filter(
            (row) =>
              row.PARENT_ITEM_CODE === targetRow["ITEM CODE"] &&
              row.ADDON_TYPE === "ACCOMPANIMENT",
          )
          .reduce((sum, row) => sum + Number(row.QTY || 0), 0);
        const auxTotal = prevItems
          .filter(
            (row) =>
              row.PARENT_ITEM_CODE === targetRow["ITEM CODE"] &&
              row.ADDON_TYPE === "AUXILIARY",
          )
          .reduce((sum, row) => sum + Number(row.QTY || 0), 0);
        const nextQty = Math.max(targetRow.QTY - 1, 0);

        if (nextQty < accTotal || nextQty < auxTotal) {
          alert(
            `Remove some accompaniment/auxiliary items first — accompaniments total ${accTotal}, auxiliary total ${auxTotal}.`,
          );
          return prevItems;
        }
      }

      return prevItems
        .map((selected) => {
          if (selected.rowId === rowId) {
            const qty =
              type === "inc" ? selected.QTY + 1 : Math.max(selected.QTY - 1, 0);

            return {
              ...selected,
              QTY: qty,
              ["VAT AMOUNT"]: qty * Number(selected?.["VAT AMOUNT"] || 0),
              ["LEVY AMOUNT"]: qty * Number(selected?.["LEVY AMOUNT"] || 0),
            };
          }
          return selected;
        })
        .filter((selected) => selected.QTY > 0);
    });
  };

  // NEW — closing accompaniment popup automatically advances to auxiliary
  const closeAccompanionPopup = () => {
    setShowAccompanionItem(false);
    if (auxiliaryList?.length > 0) {
      setShowAuxiliaryItem(true);
    } else {
      setSelectedParentItem(null);
    }
  };

  // UPDATED — closing auxiliary popup ends the add-on flow
  const closeAuxiliaryPopup = () => {
    setShowAuxiliaryItem(false);
    setSelectedParentItem(null);
  };

  // New Validation Checks

  const getParentRow = (parentItem) =>
    itemsListFromTakeOrder.find(
      (row) =>
        row["ITEM CODE"] === parentItem.OM_ITEM_CODE &&
        row["ITEM NAME"] === parentItem.OM_ITEM_DESCRIPTION &&
        !row.PARENT_ITEM_CODE,
    );

  // UPDATED — now takes an addonType so accompaniment and auxiliary
  // are tallied independently against the parent qty
  const getChildQtyTotal = (parentCode, addonType) =>
    itemsListFromTakeOrder
      .filter(
        (row) =>
          row.PARENT_ITEM_CODE === parentCode && row.ADDON_TYPE === addonType,
      )
      .reduce((sum, row) => sum + Number(row.QTY || 0), 0);

  // NEW — sums qty of all accompaniment/auxiliary rows linked to this parent
  // const getChildQtyTotal = (parentCode) =>
  //   itemsListFromTakeOrder
  //     .filter((row) => row.PARENT_ITEM_CODE === parentCode)
  //     .reduce((sum, row) => sum + Number(row.QTY || 0), 0);

  const addParentItem = (item) => {
    setvatperc(16);
    setlevyperc(2);
    setItemListFromTakeOrder((prevItems) => {
      const alreadyAdded = prevItems.some(
        (row) =>
          row["ITEM CODE"] === item.OM_ITEM_CODE &&
          row["ITEM NAME"] === item.OM_ITEM_DESCRIPTION &&
          !row.PARENT_ITEM_CODE,
      );
      if (alreadyAdded) return prevItems; // already in cart — qty is edited via +/- from here

      return [
        ...prevItems,
        {
          ...item,
          rowId: generateRowId(),
          ["ITEM CODE"]: item.OM_ITEM_CODE,
          ["ITEM NAME"]: item.OM_ITEM_DESCRIPTION,
          QTY: 1,
          UOM: item.UOM,
          ["ITEM VALUE"]: item.SELLINGPRICE,
          ["ITEM RATE"]: item.RATEEXCLUSIVE,
          ["VAT AMOUNT"]: item.VATAMT,
          ["LEVY AMOUNT"]: item.LEVYAMT,
        },
      ];
    });
    setShowTable(true);
  };

  const handleVATLEVY = (value) => {
    if (levyflag == true && vatflag == true) {
      setlevyamt(((Rate * value) / 118) * 2);
      setvatamt(Number(Rate) * value - (Number(Rate) * value) / 1.16);
    } else if (levyflag == true && vatflag == false) {
      setlevyamt(((Rate * value) / 102) * 2);
      setvatamt(0);
    } else if (levyflag == false && vatflag == true) {
      setlevyamt(0);
      setvatamt(Number(Rate) * value - (Number(Rate) * value) / 1.16);
    } else if (levyflag == false && vatflag == false) {
      setlevyamt(0);
      setvatamt(0);
    }
  };

  const fetchBackItems = (value,index) => {
    setselProductname(value["ITEM NAME"] ? value["ITEM NAME"] : "");
    setProductCode(value["ITEM CODE"] ? value["ITEM CODE"] : "");
    setQuantity(value.QTY ? value.QTY : "");
    setvatamt(value?.["VAT AMOUNT"] ? value?.["VAT AMOUNT"] : "");
    setlevyamt(value?.["LEVY AMOUNT"] ? value?.["LEVY AMOUNT"] : "");
    setRate(value["ITEM VALUE"] ? value["ITEM VALUE"] : "");
    setlevyflag(value?.["LEVY AMOUNT"] ? true : false);
    setvatflag(value?.["VAT AMOUNT"] ? true : false);
     setSelectedRowIndex(index);
  };

  const fetchBackItems1 = (value, index) => {
    setProductCode(value.ProductCode);
    setselProductname(value.ProductName ? value.ProductName : "");
    setQuantity(value.quanity ? value.quanity : "");
    setvatamt(value.vatamt ? value.vatamt : "");
    setlevyamt(value.levyamt ? value.levyamt : "");
    setRate(value.rate ? value.rate : "");
    setlevyflag(value.levyamt ? true : false);
    setvatflag(value.vatamt ? true : false);
    setSelectedRowIndex(index);
  };

  const handleCashSaleClick = (row) => {
    setShowTable(true);
    setCashSaleHistoric(true);
    setPdfData(null);
    setnewCashPOSNo(row.INVNO);
    setDate(row.INVDATE);
    setvatperc(16);
    setvatamt(row["VAT AMT"]);
    setlevyamt(row["LEVY AMT"]);
    setlevyperc(row["LEVY PERC"]);
    setGranTotalOT(row["AMOUNT INCLUSIVE VAT"]);
    console.log(row.WAITER);
    setOrderNo(row.REFDOCNO);
    console.log(row);
    setselservername(row.WAITER);
    setselclientname(row["CUSTOMER NAME"]);
    setclientcode(row["CUSTOMER CODE"]);
    setClientCurrency(row?.CURRENCYCODE);
    setClientExchRate(row?.CONVRATE);
    setseltable(row.TABLENO);
    setmobileno(row.MOBILENO);
    setSelAreaName(row?.AREA);
       setNarration(row?.NARRATION);

    setCreatedDate(row?.["CREATED DATE"]);
    setCreatedBy(row?.["CREATED BY"]);
    setCancelled(row.CANCELLED);
    setCancelledBy(row.CANCELLEDBY);
    setCancelledDate(row.CANCELLEDDATE);
    const area = areaList?.find((item) => item?.AREANAME === row?.AREA);
    setSelAreaId(area?.AREAID);

    if (row.SEATINGDELIVERY) {
      if (row.SEATINGDELIVERY == "SEATING") {
        handleOptionSelect(1);
      } else {
        handleOptionSelect(2);
      }
    }

    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=622&INVNO=${row.INVNO}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((response) => {
        setItemListFromTakeOrder(response.data);
      })
      .catch((error) => {
        console.error("Error fetching Cash Sale History Details:", error);
      });
  };
  // *************** Save Procedure ********************************

    async function DeleteHeaders() {
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1813`,
        {
          CASHSALENO: Number(newCashPOSNo),
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      );

      if (response.status === 201) {
        console.log(`Headers saved successfully`);
        await SaveHeaders()
      } else {
        console.error(`Error while saving headers`);
        alert(`Error while saving headers`);
        setisloading(false)
      }
    } catch (error) {
      console.error(`Error while saving row headers`, error);
      setisloading(false);
    }
  }

  async function SaveHeaders() {
    try {
      setisloading(true);
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=39`,
        {
          INVNO: Number(newCashPOSNo),
          WEBRELATED: 1,
          WEBORDERNO: 0,
          LPONO: "",
          INVSAGENO: 0,
          REFDOCTYPE: itemsListFromTakeOrder?.length > 0 ? "SALES ORDER" : "",
          REFDOCNO: 0,
          INVDATE: moment().format("YYYY/MM/DD"),
          INVDUEDATE: "",
          INVCATEGORY: "",
          INVCUSTCODE: clientcode,
          INVDEPARTMENT: "",
          INVSALESLOC: division,
          INVSHIPMENTMODE: "",
          INVSALESMAN: "",
          INVSALESTYPE: "",
          INVWARRANTY: 0,
          INVWARRANTYCUSTOMER: "",
          INVCURRCODE: clientCurrency || "",
          INVCURRNO: 0,
          INVCONVRATE: Number(clientExchRate) || 0,
          INVVATAMT: Number(totalVatOT),
          INVAMOUNT: Number(grandtotalOT),
          INVREMAMOUNT: 0,
          INVMISC: 0,
          INVDISCAMOUNT: 0,
          PARTSVALUE: 0,
          INVLABOR: 0,
          INVEXTSERVICEAMT: 0,
          ZERORATED: 0,
          INVSAGEPOSTED: 0,
          INVFINYEAR: 2026,
          CREATEDTIME: moment().format("HH:mm:ss"),
          CREATED_BY: userState.emailId.split("@")[0].toUpperCase(),
          INVCREATEDDATE: moment().format("YYYY/MM/DD"),
          CREATEDCOMPCODE: compCode ? compCode : "",
          CREATEDDIVISIONCODE: division,
          INVCUSTALIAS: "",
          MEMONOTE: "",
          INVJOBID: 0,
          INVPRODUCTDISCOUNTAMOUNT: 0,
          GENERALDISCOUNTAMOUNT: 0,
          INVGENERALDISCOUNTAMOUNTINCLUSIVEVAT: 0,
          INVMOBILENO: "",
          INVREGNO: "",
          INVPAYMENTMODE: "",
          INVAMOUNTPAID: Number(amountpaid) || 0,
          INVTABLENUMBER: seltable,
          INVTABLEWAITERSERVED: selservername,
          INVPAYMODE: "",
          INVPAYREFNUMBER: "",
          INVPAYREFNAME: "",
          INVLEVYAMOUNT: Number(totalLevyOT),
          LEVYPERC: Number(levyperc),
          INVTILLNO: "",
          INVMONEYRECEIVED: 0,
          INVMONEYRECEIVEDDATE: "",
          INVMONEYRECEIVEDBY: "",
          INVSERVICETYPE:
            seatingFlag === 1
              ? "SEATING"
              : seatingFlag === 2
                ? "TAKE AWAY"
                : "DELIVERY",
          AREA: selAreaName || "",
          INVNEWEXISTING: CashSaleHistoric === true ? "EXISTING" : "NEW",
          INVNARRATION: narration || "",
          SUCCESS_STATUS: "",
          ERROR_STATUS: "",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      );

      if (response.status === 201) {
        console.log(`Headers saved successfully`);
        await SaveOrderTakerDetails(response?.data?.message);
      } else {
        console.error(`Error while saving headers`);
        setisloading(false);
      }
    } catch (error) {
      console.error(`Error while saving row headers`, error);
      setisloading(false);
    }
  }

  async function SaveOrderTakerDetails(invoiceNo) {
    let successCount = 0;
    let successMessage = null;
    let errorCount = 0;
    let errorMessage = null;

    const results = await Promise.allSettled(
      itemsListFromTakeOrder.map((value, i) =>
        axios.post(
          `${BASEURL_GLOBAL}/globalSpHandler?spname=36`,
          {
            INVNO: invoiceNo ? Number(invoiceNo) : 0,
            INVDATE: moment().format("YYYY/MM/DD"),
            INVITEMINDEX: Number(i + 1),
            INVITEMCODE: value?.["ITEM CODE"],
            INVPARTNO: "",
            INVITEMNAME: value?.["ITEM NAME"],
            INVQTY: Number(value.QTY) || 0,
            INVUOM: value.UOM || "",
            INVRATE: Number(value?.["ITEM RATE"]) || 0,
            INVRATEINCLUSIVE: Number(value?.["ITEM VALUE"]) || 0,
            INVITEMISSUEDATE: "",
            INVLOCCODE: division ||"",
            INVITEMDISC: 0,
            INVITEMVAT: value?.["VAT AMOUNT"] ? 1 : 0,
            INVITEMVATAMOUNT: Number(value?.["VAT AMOUNT"]) || 0,
            INVITEMLEVY: Number(value?.["LEVY AMOUNT"]) || 0,
            INVCURRENCY: clientCurrency || "",
            INVCURRENCYNO: 0,
            INVITEMVALUE: value?.["ITEM VALUE"]
              ? Number(value?.QTY) * Number(value?.["ITEM VALUE"])
              : 0,
            INVWORKSHOPCOUNTER: "",
            INVVEHICLEREG: "",
            INVDIVISION: division,
            INVFINYEAR: 2026,
            INVCOSTPRICE: 0,
            INVCREATEDBY: userState.emailId.split("@")[0].toUpperCase(),
            INVCREATEDDATE: moment().format("YYYY/MM/DD"),
            INVCREATEDCOMPCODE: "",
            INVCOMBOQTY: 0,
            INVITEMQTYDISCOUNT: 0,
            INVASSOCIATED: 0,
            INVITEMACCOMPANIMENT: "",
            INVITEMAUXILIARY: "",
            SUCCESS_STATUS: "",
            ERROR_STATUS: "",
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessiontoken,
            },
          },
        ),
      ),
    );

    results.forEach((result) => {
      if (result.status === "fulfilled") {
        const response = result.value;
        if (response.status === 201) {
          successCount++;
          successMessage = response.data.message;
        } else {
          errorCount++;
          errorMessage = response.data.message;
        }
      } else {
        const error = result.reason;
        console.error(
          `Error while Saving Details /InsertCashSaleDetails `,
          error,
        );
        errorCount++;
        errorMessage = error?.response?.data?.message || error?.message;
      }
    });

    if (errorCount > 0) {
      setisloading(false);
    }

    if (successCount === itemsListFromTakeOrder.length && successMessage) {
      // alert("Details Saved Successfully");
      await SaveProcessFinancials(invoiceNo);
    }
    if (errorMessage) {
      alert(errorMessage);
    }
  }

  async function SaveProcessFinancials(invoiceNo) {
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1729`,
        {
          CASHSALENO: Number(invoiceNo),
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      );

      if (response.status === 201) {
        console.log(`Headers saved successfully`);
        alert("Cash Sale Saved Successfully");
        await SendCashPOS(invoiceNo)
        setisloading(false);
      } else {
        console.error(`Error while saving headers`);
        setisloading(false);
      }
    } catch (error) {
      console.error(`Error while saving row headers`, error);
      setisloading(false);
    }
  }

  // VOID
  async function CancelReceipt() {
    try {
      setisloading(true);
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1748`,
        {
          CASHSALENO: Number(newCashPOSNo),
          CANCELREASON: selReason || "",
          CANCELLEDBY: userState.emailId.split("@")[0].toUpperCase() || "",
          SUCCESS_STATUS: "",
          ERROR_STATUS: "",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      );

      if (response.status === 201) {
        alert("Cash Sale Cancelled Succesfully");
        setisloading(false);
        window.location.reload();
      } else {
        console.error(`Error while Cancelling Cash Sale`);
        alert("Cash Sale failed to cancel");
        setisloading(false);
      }
    } catch (error) {
      console.log(error);
      setisloading(false);
      console.error(`Error while Cancelling Cash Sale`, error);
    }
  }

  // CANCEL BUTTON
async function CancelCashPOS() {
  try {
    setisloading(true);

    // Step 1: Get Cash Sale product details from View 622
    const viewResponse = await axios.get(
      `${BASEURL_GLOBAL}/globalViewHandler?viewname=622&INVNO=${newCashPOSNo}`,
      {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      }
    );

    console.log("Cash Sale Details:", viewResponse.data);

    const cashSaleProducts = viewResponse.data;

    // Make sure we received product details
    if (!Array.isArray(cashSaleProducts) || cashSaleProducts.length === 0) {
      alert("No products found for this Cash Sale.");
      setisloading(false);
      return;
    }

    // Step 2: Check whether ALL products have already been sent to kitchen
    const allProductsSentToKitchen = cashSaleProducts.every(
      (item) => item.SENTTOKITCHEN === true
    );

    // Step 3: If all products are already sent, stop the process
    if (allProductsSentToKitchen) {
      alert("Products Already sent to the Kitchen");
      setisloading(false);
      return;
    }

    // Step 4: Find products which are NOT yet sent to kitchen
    const productsNotSent = cashSaleProducts.filter(
      (item) => item.SENTTOKITCHEN === false
    );

    if (productsNotSent.length === 0) {
      alert("Products Already sent to the Kitchen");
      setisloading(false);
      return;
    }

    

    // Step 5: Call SP 1806 for each unsent product 
    for (const item of productsNotSent){
      const itemCode = item?.["ITEM CODE"];
      console.log("Processing Item Code:", itemCode);
      const response = await axios.post(`${BASEURL_GLOBAL}/globalSpHandler?spname=1806`,
        {
          CASHSALENO: Number(newCashPOSNo),
          ITEMCODE: itemCode,
          SENTTOKITCHENBY: userState.emailId?.split("@")[0]?.toUpperCase() || "",
          SENDONCANCEL: "CANCEL",
          SUCCESS_STATUS: "",
          ERROR_STATUS: "",
        },
        {
          headers:
          {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        });
      console.log(`SP 1806 Response for ITEMCODE ${itemCode}:`, response.data);
      if (response.status !== 201)
      {
        console.error(`Error while cancelling ITEMCODE: ${itemCode}`);
        alert(`Cash Sale failed to cancel for Item Code: ${itemCode}`);
        setisloading(false);
        return;
      }
    }
    // All unsent products processed successfully
    alert("Cash Sale Cancelled Successfully");
    setisloading(false);
    window.location.reload();
  } catch (error) {
    console.error("Error while Cancelling Cash Sale:", error);
    alert("Error while cancelling Cash Sale");
    setisloading(false);
  }
}


    // SEND BUTTON
async function SendCashPOS(invoiceNo) {
  try {
    setisloading(true);

    // Step 1: Get Cash Sale product details from View 622
    const viewResponse = await axios.get(
      `${BASEURL_GLOBAL}/globalViewHandler?viewname=622&INVNO=${invoiceNo}`,
      {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      }
    );

    console.log("Cash Sale Details:", viewResponse.data);

    const cashSaleProducts = viewResponse.data;

    // Make sure we received product details
    if (!Array.isArray(cashSaleProducts) || cashSaleProducts.length === 0) {
      alert("No products found for this Cash Sale.");
      setisloading(false);
      return;
    }

    // Step 4: Find products which are NOT yet sent to kitchen
    const productsNotSent = cashSaleProducts.filter(
      (item) => item.SENTTOKITCHEN === false
    );

    if (productsNotSent.length === 0) {
      alert("Products Already sent to the Kitchen");
      setisloading(false);
      return;
    }

    // Step 5: Call SP 1806 for each unsent product 
    for (const item of productsNotSent){
      const itemCode = item?.["ITEM CODE"];
      console.log("Processing Item Code:", itemCode);
      const response = await axios.post(`${BASEURL_GLOBAL}/globalSpHandler?spname=1806`,
        {
          CASHSALENO: Number(invoiceNo),
          ITEMCODE: itemCode,
          SENTTOKITCHENBY: userState.emailId?.split("@")[0]?.toUpperCase() || "",
          SENDONCANCEL: "SEND",
          SUCCESS_STATUS: "",
          ERROR_STATUS: "",
        },
        {
          headers:
          {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        });
      console.log(`SP 1806 Response for ITEMCODE ${itemCode}:`, response.data);
      if (response.status !== 201)
      {
        console.error(`Error while cancelling ITEMCODE: ${itemCode}`);
        alert(`Cash Sale failed to Send for Item Code: ${itemCode}`);
        setisloading(false);
        return;
      }
    }
    // All unsent products processed successfully
    alert("Cash Sale Sent To Kitchen Successfully");
    setisloading(false);
    window.location.reload();
  } catch (error) {
    console.error("Error while Sending Cash Sale:", error);
    alert("Error while Sending Cash Sale");
    setisloading(false);
  }
}

  async function ModifyClient() {
    try {
      setisloading(true);
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1750`,
        {
          CASHSALENO: Number(newCashPOSNo),
          MODIFYCLIENT: selClientForCredit || "",
          PREVIOUSCLIENT: selclientname || "",
          MODIFYBY: userState.emailId.split("@")[0].toUpperCase() || "",
          SUCCESS_STATUS: "",
          ERROR_STATUS: "",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      );

      if (response.status === 201) {
        alert("Cash Sale Client Modified Succesfully");
        setisloading(false);
        window.location.reload();
      } else {
        console.error(`Error while Modifying Cash Sale Client`);
        alert("Cash Sale Client failed to modify");
        setisloading(false);
      }
    } catch (error) {
      console.log(error);
      setisloading(false);
      console.error(`Error while Modifying Cash Sale client`, error);
    }
  }

  // const closeAccompanionPopup = () => {
  //   console.log(auxiliaryList);
  //   setShowAccompanionItem(false);
  //   setAccompanionList([]);
  //   if (auxiliaryList?.length > 0) {
  //     setShowAuxiliaryItem(true);
  //   }
  // };

  // const closeAuxiliaryPopup = () => {
  //   setShowAuxiliaryItem(false);
  //   setAuxiliaryList([]);
  // };

  function checkIfCashPosIsDoneOrNot(cash) {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=624&INVNO=${cash}`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        if (response?.data?.length > 0) {
          setCashPo(newCashPOSNo);
          setShowReceipts(true);
        } else {
          alert(`This Cash Pos No ${newCashPOSNo} is not saved yet`);
        }
      })
      .catch((error) => {
        console.error("Error fetching List Of Cash Sale History:", error);
      });
  }

  // Crystal Reports
  function generateReport() {
    setPdfData(null);

    if (!newCashPOSNo) {
      alert("Please select a Cash Sale NO");
      return;
    }
    setLoadingScreenBlock(true);
    axios
      .post(
        `${BASEURL}/generateReports`,
        {
          REPORTNAME: "CrBillPaid.rpt",
          DOCNO: Number(newCashPOSNo),
          REPORTPATH: company?.REPORTPATH,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
          responseType: "blob",
        },
      )
      .then((res) => {
        console.log(res);
        const file = new Blob([res.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        setPdfData(fileURL);
        setLoadingScreenBlock(false);
      })
      .catch((err) => {
        console.log("Error generating report:", err);
        setLoadingScreenBlock(false);
      });
  }

  const handleDownload = () => {
    const a = document.createElement("a");
    a.href = pdfData;
    a.download = "generated_report.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const ClearAll = () => {
    setSeatingFlag(null);
    setDate(new Date()?.toISOString());
    setvatperc(null);
    setvatamt(null);
    setlevyamt(null);
    setlevyperc(null);
    setGranTotalOT("");
    setselservername(userid);
    setselclientname("");
    setclientcode("");
    setClientCurrency("");
    setClientExchRate("");
    setseltable("");
    setSelAreaName("");
    setNarration("");
    setSelAreaId("");
    setlistoftables([]);
    setItemListFromTakeOrder([]);
    setCashSaleHistoric(false);
    setShowTable(false);
    setisloading(true);
    hideNavbar = false
    ordernoToPass = null
    getALLData();
  };

  return (
    <>
      {isloading ? (
        <Loading />
      ) : (
        <div>
          {!hideNavbar && <DashBoardNavbar />}
          {!hideNavbar && <HomePageNavbarFinancials />}

          {/* Top title bar */}
          <div className="w-full bg-[#002e62db] flex flex-col sm:flex-row flex-wrap items-center sm:items-stretch gap-1 px-3 py-1 my-2 justify-between text-center sm:text-left">
            <p className="text-white sm:ml-2 lg:mr-14">
              Mars Track Point of Sale
            </p>
            <p className="text-white sm:mr-2 lg:ml-24">
              {moment(date).format("DD/MM/YYYY")}
            </p>
            <p className="text-white sm:mr-2 lg:mr-48">{currentTime}</p>
          </div>

          <div className="w-full h-auto">
            {/* Status Line  */}
            {CashSaleHistoric === true && (
              <div className="flex flex-wrap ml-2 gap-1 mb-2">
                <p className="font-bold">Created By:</p>
                <span className="text-red-500">{createdBy}</span>
                <p className="font-bold">|</p>
                <p className="font-bold">Created Date:</p>
                <span className="text-red-500">
                  {createdDate ? moment(createdDate).format("DD/MM/YYYY") : ""}
                </span>
                <p className="font-bold">|</p>
                <p className="font-bold">Cancellation Status:</p>
                <span className="text-red-500">
                  {cancelled === true ? "CANCELLED" : "NOT CANCELLED"}
                </span>
                <p className="font-bold">|</p>
                {cancelled === true && (
                  <>
                    <p className="font-bold">Cancelled By:</p>
                    <span className="text-red-500">{cancelledBy}</span>
                    <p className="font-bold">|</p>
                    <p className="font-bold">Cancelled Date:</p>
                    <span className="text-red-500">
                      {cancelledDate
                        ? moment(cancelledDate).format("DD/MM/YYYY")
                        : ""}
                    </span>
                  </>
                )}
              </div>
            )}

            {/* Action buttons row */}
            <div className="flex flex-wrap gap-1 my-2 mx-2 lg:ml-[10px] lg:mr-0">
              <button
                className="h-8 border border-black bg-[#002d62] text-white rounded-md px-3 py-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
                onClick={() => handleButtonClick("first")}
              >
                {"<<"}
              </button>
              <button
                className="h-8 border border-black bg-[#002d62] text-white rounded-md px-3 py-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
                onClick={() => handleButtonClick("decrement")}
              >
                {"<"}
              </button>
              <button
                className="h-8 border border-black bg-[#002d62] text-white rounded-md px-3 py-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
                onClick={() => handleButtonClick("increment")}
              >
                {">"}
              </button>
              <button
                className="h-8 border border-black bg-[#002d62] text-white rounded-md px-3 py-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
                onClick={() => handleButtonClick("latest")}
              >
                {">>"}
              </button>

              <div className="flex flex-wrap gap-2 w-full sm:w-auto mt-1 sm:mt-0">
                <button
                  className="flex h-8 items-center justify-center border border-black bg-red-950 text-white rounded-md px-3 py-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => {
                    ClearAll();
                  }}
                >
                  New
                </button>
                <button
                  className="flex h-8 items-center justify-center border border-black bg-pink-600 text-white rounded-md px-3 py-1 hover:bg-pink-700 focus:outline-none focus:ring focus:border-blue-300"
                  onClick={async () => {
                    if (CashSaleHistoric === true) {
                      setisloading(true);
                      axios
                        .get(
                          `${BASEURL_GLOBAL}/globalViewHandler?viewname=1680&BILLNO=${newCashPOSNo}`,
                          {
                            headers: {
                              "auth-token": authToken,
                              "session-token": sessiontoken,
                            },
                          },
                        )
                        .then(async (res) => {
                          setisloading(false);
                          if (res?.data?.length > 0 && res?.data?.[0]?.RECEIPTAMOUNT > 0) {
                            alert("This bill has been receipted");
                            return;
                          } else {
                            await DeleteHeaders();
                            // window.location.reload();
                            ClearAll();
                          }
                        })
                        .catch((err) => {
                          setisloading(false);
                          console.log("Error While fetching 1680", err);
                        });
                    } else {
                      if (!newCashPOSNo) {
                        alert("Kindly Provide Cash POS No");
                      } else if (!clientcode) {
                        alert("Kindly Supply Client Code");
                      } else if (seatingFlag === 1 && !selAreaName) {
                        alert("Kindly Supply Area");
                      } else if (seatingFlag === 1 && !seltable) {
                        alert("Kindly Supply Table");
                      } else if (itemsListFromTakeOrder.length === 0) {
                        alert("Kindly Add Items first");
                      } else {
                        await SaveHeaders();
                        // window.location.reload();
                        ClearAll();
                      }
                    }
                  }}
                >
                  Save
                </button>
                  <button className="flex h-8 items-center justify-center border border-black bg-blue-600 text-white rounded-md px-3 py-1 hover:bg-blue-700 focus:outline-none focus:ring focus:border-blue-300"
                    onClick={async() => {
                      if (!CashSaleHistoric) {
                      alert("Kindly Select Saved CashPos")
                      } else {
                       await SendCashPOS(newCashPOSNo)
                    }
                  }}
                    
                  >
                  Send
                </button>
                <button
                  className="flex h-8 items-center justify-center border border-black bg-blue-600 text-white rounded-md px-3 py-1 hover:bg-blue-700 focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => {
                    if (CashSaleHistoric === false) {
                      alert("Kindly Save the Cash Sale first");
                    } else {
                      setPopUpReport(true);
                      generateReport();
                    }
                  }}
                >
                  Print
                </button>
              </div>

              <div className="flex flex-wrap gap-2 w-full sm:w-auto mt-1 sm:mt-0">
                <button
                  className="flex h-8 items-center justify-center border border-black bg-gray-600 text-white rounded-md px-3 py-1 hover:bg-gray-700 focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => {
                    checkIfCashPosIsDoneOrNot(newCashPOSNo);
                  }}
                >
                  Receive Money
                </button>
                <button
                  className="flex h-8 items-center justify-center border border-black bg-sky-600 text-white rounded-md px-3 py-1 hover:bg-sky-700 focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => {
                    if (CashSaleHistoric === true) {
                      setShowBillActions(true);
                    } else {
                      alert("Kindly Select saved Cash sale");
                    }
                  }}
                >
                  Bill Actions
                </button>

                {showBillActions && (
                  <div className="fixed top-[70px] left-1/2 -translate-x-1/2 bg-white border border-black h-[300px] w-[95%] sm:w-[90%] lg:w-[900px] p-1 overflow-y-auto z-[500] rounded-md shadow-xl">
                    <div className="flex flex-wrap justify-center gap-2 mt-6 sm:mt-20 px-2">
                      <button className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2 focus:outline-none focus:ring focus:border-blue-300">
                        MPESA PROMPT
                      </button>
                        <button className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2 focus:outline-none focus:ring focus:border-blue-300"
                          onClick={() => {
                          setShowSplitBills(true)
                        }}
                        >
                        SPLIT BILL
                      </button>
                      <button className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2 focus:outline-none focus:ring focus:border-blue-300"
                          onClick={() => {
                        setShowMergeBills(true)
                      }}
                        >
                        MERGE BILLS
                      </button>
                      <button
                        className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2 focus:outline-none focus:ring focus:border-blue-300"
                        onClick={() => {
                          getNewCashPosNo();
                          setCashSaleHistoric(false);
                          alert(
                            "A new Transaction has been generated, proceed to save or edit",
                          );
                        }}
                      >
                        Duplicate and New
                      </button>
                      <button
                        className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2 focus:outline-none focus:ring focus:border-blue-300"
                        onClick={() => {
                          setisloading(true);
                          axios
                            .get(
                              `${BASEURL_GLOBAL}/globalViewHandler?viewname=1713&ORDERNO=${newCashPOSNo}`,
                              {
                                headers: {
                                  "auth-token": authToken,
                                  "session-token": sessiontoken,
                                },
                              },
                            )
                            .then((res) => {
                              setisloading(false);
                              if (res?.data?.length > 0) {
                                alert("This bill has been receipted");
                                return;
                              } else {
                                const isCancel = window.confirm(
                                  "This action is not reversable, are you sure you want to proceed?",
                                );
                                if (isCancel === true) {
                                  setShowCancel(true);
                                } else {
                                  setShowCancel(false);
                                }
                              }
                            })
                            .catch((err) => {
                              setisloading(false);
                              console.log("Error While fetching 1713", err);
                            });
                        }}
                      >
                        VOID BILL
                      </button>
                      {/* <button className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2 focus:outline-none focus:ring focus:border-blue-300"
                      onClick={async() => {
                        await CancelCashPOS();
                        }}
                        >
                        CANCEL
                      </button> */}
                      <button
                        className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2 focus:outline-none focus:ring focus:border-blue-300"
                        onClick={() => {
                          const isCreditClient = window.confirm(
                            "This action is not reversable, are you sure you want to proceed?",
                          );
                          if (isCreditClient === true) {
                            setShowCreditClient(true);
                          } else {
                            setShowCreditClient(false);
                          }
                        }}
                      >
                        CREDIT CLIENT
                      </button>
                    </div>

                    <button
                      className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                      onClick={() => setShowBillActions(false)}
                    >
                      Close
                    </button>
                  </div>
                )}

                {showCancel && (
                  <div className="fixed top-[70px] left-1/2 -translate-x-1/2 bg-white border border-black h-[300px] w-[95%] sm:w-[80%] lg:w-[500px] p-1 overflow-y-auto z-[500] rounded-md shadow-xl">
                    <div className="flex flex-wrap items-center gap-2 mt-5 px-2">
                      <p className="text-red-600">Reason :</p>
                      <Select
                        className="w-full sm:w-64"
                        onChange={(e) => {
                          setSelReason(e.value);
                        }}
                        value={
                          selReason
                            ? { label: selReason, value: selReason }
                            : { label: "", value: "" }
                        }
                        options={[
                          { value: "", label: "" },
                          ...cancelReasonList?.map((item) => ({
                            label: item.REASON,
                            value: item.REASON,
                          })),
                        ]}
                      />
                    </div>

                    <div className="flex flex-wrap justify-center gap-2 mt-6 sm:mt-20 px-2">
                      <button
                        className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2 focus:outline-none focus:ring focus:border-blue-300"
                        onClick={() => {
                          if (selReason) {
                            CancelReceipt();
                          } else {
                            alert("Kindly Supply Reason");
                          }
                        }}
                      >
                        Void Bill
                      </button>
                    </div>

                    <button
                      className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                      onClick={() => setShowCancel(false)}
                    >
                      Close
                    </button>
                  </div>
                )}

                {showCreditClient && (
                  <div className="fixed top-[70px] left-1/2 -translate-x-1/2 bg-white border border-black h-[300px] w-[95%] sm:w-[80%] lg:w-[500px] p-1 overflow-y-auto z-[500] rounded-md shadow-xl">
                    <div className="flex flex-wrap items-center gap-2 mt-5 px-2">
                      <p className="text-red-600">Client Name :</p>
                      <Select
                        className="w-full sm:w-64"
                        onChange={(e) => {
                          setSelClientForCredit(e.value);
                        }}
                        value={
                          selClientForCredit
                            ? {
                                label: selClientForCredit,
                                value: selClientForCredit,
                              }
                            : { label: "", value: "" }
                        }
                        options={[
                          { value: "", label: "" },
                          ...clientListForCredit?.map((item) => ({
                            label: item.CLIENTNAME,
                            value: item.CLIENTNAME,
                          })),
                        ]}
                      />
                    </div>

                    <div className="flex flex-wrap justify-center gap-2 mt-6 sm:mt-20 px-2">
                      <button
                        className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2 focus:outline-none focus:ring focus:border-blue-300"
                        onClick={() => {
                          if (selClientForCredit) {
                            if (selClientForCredit === selclientname) {
                              alert(
                                "This client to modify can not be same as previous client",
                              );
                            } else {
                              ModifyClient();
                            }
                          } else {
                            alert("Kindly Supply Client Name");
                          }
                        }}
                      >
                        MODIFY CLIENT
                      </button>
                    </div>

                    <button
                      className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                      onClick={() => setShowCreditClient(false)}
                    >
                      Close
                    </button>
                  </div>
                )}

                <button
                  className="flex h-8 items-center justify-center border border-black bg-indigo-900 text-white rounded-md px-3 py-1 hover:bg-indigo-800 focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => {
                    setShowSales(true);
                  }}
                >
                  Sales Today
                </button>
              </div>
            </div>

            {/* HomePage */}
            {showSales && (
              <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/20 p-2">
                <div className="relative bg-white border border-black h-[90vh] lg:h-[calc(100vh-90px)] w-full lg:w-[1300px] p-1 overflow-y-auto rounded-md shadow-xl">
                  <HomePage hideNavBar={true} />
                  <button
                    className="absolute top-1 right-1 flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 focus:outline-none focus:ring focus:border-blue-300"
                    onClick={() => setShowSales(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            )}

            {/* Cash POS No / order type / division */}
            <section className="lg:flex">
              <div className="flex flex-col sm:flex-row flex-wrap items-start sm:items-center gap-2 mb-2 mt-2 mx-2 lg:ml-[10px]">
                <div className="flex items-center gap-2">
                  <p className="text-red-600">Credit Note Cash No:</p>
                  <input
                    className="w-32 h-8 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                    value={newCashPOSNo}
                    readOnly
                  />
                  <button
                    className="flex h-8 items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
                    onClick={() => setcashsalepopup(true)}
                  >
                    ...
                  </button>
                </div>

                {cashsalepopup && (
                  <div className="fixed top-[100px] inset-0 z-50 flex items-center justify-center bg-black/40 p-2">
                    <div className="relative bg-white border border-black h-[85vh] lg:h-[500px] w-full max-w-[95vw] lg:w-[900px] p-1 overflow-y-auto rounded-md">
                      <div className="flex flex-col sm:flex-row flex-wrap gap-2 mt-2 px-2">
                        <div className="flex items-center gap-2 w-full sm:w-auto">
                          <p className="text-red-600 whitespace-nowrap">
                            Search:
                          </p>
                          <input
                            className="w-full sm:w-64 h-8 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                            type="text"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                          />
                        </div>
                        <div className="flex items-center gap-2">
                          <p className="text-red-600 whitespace-nowrap">
                            Start Date:
                          </p>
                          <input
                            type="date"
                            className="w-36 h-8 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                            onChange={(e) => setstartdate(e.target.value)}
                            value={startdate.split("T")[0]}
                          />
                        </div>
                        <div className="flex items-center gap-2">
                          <p className="text-red-600 whitespace-nowrap">
                            End Date:
                          </p>
                          <input
                            type="date"
                            className="w-36 h-8 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                            onChange={(e) => setEnddate(e.target.value)}
                            value={enddate.split("T")[0]}
                          />
                        </div>
                      </div>

                      <button
                        className="absolute top-2 right-2 flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
                        onClick={() => setcashsalepopup(false)}
                      >
                        Close
                      </button>

                      <aside className="table__pos__app text-sm mt-3 overflow-x-auto">
                        <table class="custom-table w-full">
                          <thead class="header-cell">
                            <tr>
                              <td className="pl-2 whitespace-nowrap">
                                Cash Sale No
                              </td>
                              <td className="text-left whitespace-nowrap">
                                Date
                              </td>
                              <td className="text-left whitespace-nowrap">
                                Sales Location
                              </td>
                              <td className="text-left whitespace-nowrap">
                                Customer Name
                              </td>
                              <td className="text-right whitespace-nowrap">
                                Financial Year
                              </td>
                              <td className="text-right whitespace-nowrap">
                                Amount
                              </td>
                            </tr>
                          </thead>
                          <tbody>
                            {filtHistoricCash.map((row, index) => (
                              <tr
                                key={row.INVNO}
                                onClick={() => {
                                  setcashsalepopup(false);
                                  handleCashSaleClick(row);
                                }}
                                className={
                                  index < listofCashSales1.length
                                    ? "border-b cursor-pointer text-sm table-row"
                                    : ""
                                }
                              >
                                <td className="text-right pr-12 whitespace-nowrap">
                                  {row.INVNO ? row.INVNO : ""}
                                </td>
                                <td className="text-left whitespace-nowrap">
                                  {row.INVDATE
                                    ? moment(row.INVDATE.split("T")[0]).format(
                                        "DD/MM/YYYY",
                                      )
                                    : ""}
                                </td>
                                <td className="text-left whitespace-nowrap">
                                  {row["SALES LOC"] ? row["SALES LOC"] : ""}
                                </td>
                                <td className="text-left whitespace-nowrap">
                                  {row["CUSTOMER NAME"]
                                    ? row["CUSTOMER NAME"]
                                    : ""}
                                </td>
                                <td className="text-right whitespace-nowrap">
                                  {row["FINANCIAL YEAR"]
                                    ? row["FINANCIAL YEAR"]
                                    : ""}
                                </td>
                                <td className="text-right whitespace-nowrap">
                                  {row["AMOUNT INCLUSIVE VAT"]
                                    ? row[
                                        "AMOUNT INCLUSIVE VAT"
                                      ]?.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    : ""}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </aside>
                    </div>
                  </div>
                )}

                <div className="flex flex-wrap items-center gap-2">
                  <p className="text-red-600">Order Type :</p>
                  <label className="flex items-center gap-1">
                    <input
                      type="radio"
                      checked={seatingFlag === 1}
                      onChange={() => {
                        handleOptionSelect(1);
                        setShowArea(true);
                      }}
                      disabled={CashSaleHistoric == true}
                    />
                    <span className="text-red-600">Seating</span>
                  </label>
                  <label className="flex items-center gap-1">
                    <input
                      type="radio"
                      checked={seatingFlag === 2}
                      onChange={() => {
                        setseltable("");
                        handleOptionSelect(2);
                      }}
                      disabled={CashSaleHistoric == true}
                    />
                    <span className="text-red-600">Take away</span>
                  </label>
                  <label className="flex items-center gap-1">
                    <input
                      type="radio"
                      checked={seatingFlag === 3}
                      onChange={() => {
                        setseltable("");
                        handleOptionSelect(3);
                      }}
                      disabled={CashSaleHistoric == true}
                    />
                    <span className="text-red-600">Delivery</span>
                  </label>
                </div>

                <div className="flex items-center gap-2 w-full sm:w-auto">
                  <p className="text-red-600 whitespace-nowrap">Division :</p>
                  <select
                    onChange={(e) => {
                      setdivsion(e.target.value);
                      dispatch(setDivision(e.target.value));
                    }}
                    className="w-full sm:w-48 h-6 border-black border rounded"
                  >
                    <option>{divisionState}</option>
                    {userdivisionRights.map((item) =>
                      item.OM_USER_DIVISION !== divisionState ? (
                        <option
                          key={item.OM_USER_DIVISION}
                          value={item.OM_USER_DIVISION}
                        >
                          {item.OM_USER_DIVISION}
                        </option>
                      ) : null,
                    )}
                  </select>
                </div>
              </div>
            </section>

            {/* Area / Table pick popup */}
            {showArea && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-2">
                <div className="bg-white rounded-lg shadow-2xl w-full max-w-[92vw] lg:w-[520px] max-h-[80vh] overflow-y-auto p-4 sm:p-6">
                  <p className="text-red-600 mb-2">Area :</p>

                  <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 border border-gray-300 rounded-md overflow-hidden mb-4">
                    {areaList?.map((item) => {
                      const isSelectedArea = selAreaId === item.AREAID;
                      const isDisabledArea =
                        seatingFlag === 2 ||
                        seatingFlag === 3 ||
                        seatingFlag === null ||
                        CashSaleHistoric == true;

                      return (
                        <button
                          key={item.AREAID}
                          type="button"
                          disabled={isDisabledArea}
                          onClick={() => {
                            setSelAreaName(item.AREANAME);
                            setSelAreaId(item.AREAID);
                            const tablesList = allTablesList?.filter(
                              (t) => t?.AREAID === item.AREAID,
                            );
                            setlistoftables(tablesList);
                            setseltable("");
                          }}
                          className={`
                    px-2 py-3 text-xs sm:text-sm font-medium border-r border-b border-gray-300 -mr-px -mb-px
                    ${isSelectedArea ? "bg-blue-600 text-white" : "bg-white text-gray-800 hover:bg-gray-100"}
                    ${isDisabledArea ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
                  `}
                        >
                          {item.AREANAME}
                        </button>
                      );
                    })}
                  </div>

                  {selAreaId && listoftables?.length > 0 && (
                    <>
                      <p className="text-red-600 mb-2">Table No :</p>
                      <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 border border-gray-300 rounded-md overflow-hidden">
                        {listoftables.map((item) => {
                          const isSelectedTable = seltable === item.TABLENUMBER;
                          const isDisabledTable =
                            seatingFlag === 2 ||
                            seatingFlag === 3 ||
                            seatingFlag === null ||
                            CashSaleHistoric == true;

                          return (
                            <button
                              key={item.TABLENUMBER}
                              type="button"
                              disabled={isDisabledTable}
                              onClick={() => {
                                setseltable(item.TABLENUMBER);
                                setShowArea(false);
                              }}
                              className={`
                        px-2 py-3 text-xs sm:text-sm font-medium border-r border-b border-gray-300 -mr-px -mb-px
                        ${isSelectedTable ? "bg-blue-600 text-white" : "bg-white text-gray-800 hover:bg-gray-100"}
                        ${isDisabledTable ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
                      `}
                            >
                              {item.TABLENUMBER}
                            </button>
                          );
                        })}
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}

            {/* Client / currency / exch rate / date */}
            <section className="flex flex-col lg:flex-row flex-wrap gap-2 mx-2 lg:mx-0">
              <div className="flex items-center gap-1 lg:ml-[10px]">
                <p className="text-red-600 w-[70px] lg:w-auto">Client:</p>
                <div className="w-full sm:w-[250px]">
                  <Select
                    styles={customStyless}
                    onChange={(e) => {
                      setselclientname(e.value);
                      handlleClientDetails(e.value);
                      // if (seatingFlag === 1) setShowArea(true);
                    }}
                    value={
                      selclientname
                        ? { label: selclientname, value: selclientname }
                        : { label: "", value: "" }
                    }
                    options={listofClients.map((item) => ({
                      label: item.CLIENTNAME,
                      value: item.CLIENTNAME,
                    }))}
                    isDisabled={
                      CashSaleHistoric == true || seatingFlag === null
                    }
                  />
                </div>
              </div>

              <div className="flex flex-wrap items-center gap-2">
                <input
                  className="w-28 h-8 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                  value={clientcode}
                  disabled={CashSaleHistoric == true}
                  readOnly
                />
                <p className="text-red-600">Currency :</p>
                <input
                  className="w-20 h-8 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                  value={clientCurrency}
                  disabled={CashSaleHistoric == true}
                  readOnly
                />
                <p className="text-red-600">Exch Rate:</p>
                <input
                  className="w-20 h-8 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                  value={clientExchRate}
                  disabled={CashSaleHistoric == true}
                  readOnly
                />
              </div>

              <div className="flex items-center gap-2 mb-2 mt-2">
                <p className="text-red-600">Date:</p>
                <input
                  type="date"
                  className="w-32 h-8 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                  value={date?.split("T")[0]}
                  readOnly
                  disabled={CashSaleHistoric == true}
                />
              </div>
            </section>

            {/* Area / Table / Served by selects */}
            <section className="lg:flex">
              <div className="flex flex-col lg:flex-row flex-wrap gap-2 mb-2 mt-2 mx-2 lg:mx-0 lg:ml-[10px]">
                <div className="flex items-center gap-1">
                  <p className="text-red-600 w-20 lg:w-auto">Area :</p>
                  <div className="w-full sm:w-64">
                    <Select
                      styles={customStyless}
                      onChange={(e) => {
                        if (e.value !== "") {
                          setSelAreaName(e.label);
                          setSelAreaId(e.value);
                          const tablesList = allTablesList?.filter(
                            (item) => item?.AREAID === e.value,
                          );
                          setlistoftables(tablesList);
                          setShowTable(true);
                        } else {
                          setSelAreaName(e.label);
                          setSelAreaId(e.value);
                        }
                      }}
                      value={
                        selAreaName
                          ? { label: selAreaName, value: selAreaName }
                          : { label: "Select Area", value: "" }
                      }
                      options={[
                        { label: "Select Area", value: "" },
                        ...areaList?.map((item) => ({
                          label: item.AREANAME,
                          value: item.AREAID,
                        })),
                      ]}
                      isDisabled={
                        seatingFlag === 2 ||
                        seatingFlag === 3 ||
                        seatingFlag === null ||
                        CashSaleHistoric == true
                      }
                    />
                  </div>
                </div>

                <div className="flex items-center gap-1">
                  <p className="text-red-600 w-20 lg:w-auto">Table No:</p>
                  <div className="w-full sm:w-64">
                    <Select
                      styles={customStyless}
                      onChange={(e) => setseltable(e.value)}
                      value={
                        seltable
                          ? { label: seltable, value: seltable }
                          : { label: "", value: "" }
                      }
                      options={listoftables.map((item) => ({
                        label: item.TABLENUMBER,
                        value: item.TABLENUMBER,
                      }))}
                      isDisabled={
                        seatingFlag === 2 ||
                        seatingFlag === 3 ||
                        seatingFlag === null ||
                        CashSaleHistoric == true
                      }
                    />
                  </div>
                </div>

                <div className="flex items-center gap-1">
                  <p className="text-red-600 w-24 lg:w-auto">Served by:</p>
                  <div className="w-full sm:w-64">
                    <Select
                      styles={customStyless}
                      onChange={(e) => setselservername(e.value)}
                      value={
                        selservername
                          ? { label: selservername, value: selservername }
                          : { label: "", value: "" }
                      }
                      options={listofservers.map((item) => ({
                        label: item.WAITER,
                        value: item.WAITER,
                      }))}
                      isDisabled={
                        CashSaleHistoric == true || seatingFlag === null
                      }
                    />
                  </div>
                </div>
              </div>
            </section>
          </div>

          {/* Product / Quantity / Rate / Add / Remove */}
          <section className="flex flex-col lg:flex-row flex-wrap gap-2 mx-2 lg:mx-0">
            <div className="flex flex-wrap items-center gap-2 mt-2 lg:ml-[10px]">
              <p className="text-red-600 w-[80px] lg:w-auto">Product</p>
              <input
                className="w-full sm:w-64 h-8 border border-black lg:ml-1 p-2 rounded-md focus:outline-none focus:border-blue-500"
                value={selProductname}
                readOnly
              />
              <button
                className="flex h-8 items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
                onClick={() => {
                  if (seatingFlag === null) {
                    alert("Kindly Choose Seating Or TakeAway Or Delivery");
                  } else if (seatingFlag === 1 && !seltable) {
                    alert("Kindly Select Table No");
                  } else {
                    handleSearchClick();
                  }
                }}
              >
                Search
              </button>
            </div>

            <div className="flex flex-wrap items-center gap-2 mt-2">
              <p className="text-red-600">Quantity:</p>
              <input
                className="w-16 h-8 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                onChange={(e) => {
                  if (!selProductname) {
                    alert("Kindly choose the product first");
                  } else {
                    if (e.target.value > actualQuantity) {
                      alert("You are exceeding the quantity in stock");
                      setQuantity(1);
                      handleVATLEVY(1);
                    } else {
                      setQuantity(e.target.value);
                      handleVATLEVY(e.target.value);
                    }
                  }
                }}
                value={Quantity}
                disabled={CashSaleHistoric == true}
              />
              <p className="text-red-600">Rate:</p>
              <input
                className="w-20 h-8 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                value={Rate?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
                readOnly
                />
                                <button
                  className="flex w-[100px] h-8 items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => {
                    if (selectedRowIndex !== null) {
                      RemoveItems()
                    } else {
                      alert("Kindly Select the Item to Remove")
                      return;
                    }
                  }}
                >
                  Remove
                  </button>
              <div className="flex flex-wrap gap-2 lg:ml-5">
                {/* <button
                  className="flex w-[100px] items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => AddCostItem()}
                >
                  Add
                </button> */}

                   <p className="text-red-600">Narration:</p>
                  <textarea
                    rows={2}
                                  className="w-96 border resize-none border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                    value={narration}
                    onChange={(e) => {
                      setNarration(e.target.value)
                    }}
                  ></textarea>
              </div>
            </div>
          </section>

          {/* Product picker popup */}
          {isPopupOpen && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-2">
              <div className="bg-white border border-black h-[90vh] lg:h-[78%] w-full lg:w-[95%] p-1 overflow-y-auto rounded-md">
                <div className="w-full flex flex-col lg:flex-row">
                  {/* Categories */}
                  <div className="w-full lg:w-[620px] flex flex-wrap overflow-y-auto max-h-[220px] lg:max-h-[500px]">
                    {catList.map((item, index) => (
                      <aside
                        key={index}
                        className={`rounded-md border border-black shadow-xl text-center p-2 ml-2 mt-2 cursor-pointer w-20 sm:w-24 flex flex-col items-center ${
                          selcategory === item.MAINCATEGORY
                            ? "bg-[#002e62dd] text-white"
                            : "bg-white"
                        }`}
                        onClick={() => {
                          setselcategory(item.MAINCATEGORY);
                          const itemsList = allProdsList?.filter(
                            (items) =>
                              items?.MAINCATEGORY === item.MAINCATEGORY,
                          );
                          const uniqueSubCatsCat = [
                            ...new Map(
                              itemsList?.map((item) => [
                                item.SUBCATEGORY,
                                item,
                              ]),
                            ).values(),
                          ];
                          setSubCatList(uniqueSubCatsCat);
                          setProdList([]);
                        }}
                      >
                        {/* {item.CATEGORYIMAGE?.data ? (
                          <img
                            className="text-amber-950"
                            src={URL.createObjectURL(
                              new Blob(
                                [new Uint8Array(item.CATEGORYIMAGE?.data)],
                                {
                                  type: "image/jpeg",
                                },
                              ),
                            )}
                          />
                        ) : (
                          <IoFastFoodOutline
                            size={40}
                            className={
                              selcategory === item.MAINCATEGORY
                                ? "text-white"
                                : "text-[#002e62]"
                            }
                          />
                        )} */}
                        <p className="text-xs">{item.MAINCATEGORY}</p>
                      </aside>
                    ))}
                  </div>

                  {/* Sub Category */}
                  <div className="w-full lg:w-[620px] flex flex-wrap overflow-y-auto max-h-[220px] lg:max-h-[500px]">
                    {subCatList?.length > 0 &&
                      subCatList.map((item, index) => (
                        <aside
                          key={index}
                          className={`rounded-md border border-black shadow-xl text-center p-2 ml-2 mt-2 cursor-pointer w-20 sm:w-24 flex flex-col items-center ${
                            selSubCategory === item.SUBCATEGORY
                              ? "bg-[#002e62dd] text-white"
                              : "bg-white"
                          }`}
                          onClick={() => {
                            setSelSubCategory(item.SUBCATEGORY);
                            setistable(true);
                            const itemsList = allProdsList?.filter(
                              (items) =>
                                items?.MAINCATEGORY === selcategory &&
                                items?.SUBCATEGORY === item.SUBCATEGORY,
                            );
                            setProdList(itemsList);
                            setistable(false);
                          }}
                        >
                          {/* {item.CATEGORYIMAGE?.data ? (
                            <img
                              className="text-amber-950"
                              src={URL.createObjectURL(
                                new Blob(
                                  [new Uint8Array(item.CATEGORYIMAGE?.data)],
                                  {
                                    type: "image/jpeg",
                                  },
                                ),
                              )}
                            />
                          ) : (
                            <IoFastFoodOutline
                              size={40}
                              className={
                                selSubCategory === item.SUBCATEGORY
                                  ? "text-white"
                                  : "text-[#002e62]"
                              }
                            />
                          )} */}
                          <p className="text-xs">{item.SUBCATEGORY}</p>
                        </aside>
                      ))}
                  </div>

                  {/* Products */}
                  <div className="w-full lg:w-[800px] h-auto pb-2">
                    <div className="flex justify-end">
                      <IoClose
                        size={30}
                        className="text-[#002e62] cursor-pointer"
                        onClick={() => setPopupOpen(false)}
                      />
                    </div>

                    {table ? (
                      <Loading />
                    ) : (
                      <div className="w-full lg:w-[620px] flex flex-wrap justify-center sm:justify-around overflow-y-auto max-h-[400px] lg:max-h-[500px]">
                        {prodList.map((item, index) => {
                          const selectedItem = itemsListFromTakeOrder?.find(
                            (value) =>
                              value["ITEM CODE"] === item.OM_ITEM_CODE &&
                              value["ITEM NAME"] === item.OM_ITEM_DESCRIPTION &&
                              !value.PARENT_ITEM_CODE,
                          );
                          const qty = selectedItem?.QTY || 0;

                          // Precompute add-on availability for this item
                          const itemAccList = fullacompanionList?.filter(
                            (a) => a?.PARENTITEMCODE === item.OM_ITEM_CODE,
                          );
                          const itemAuxList = fullauxiliaryList?.filter(
                            (a) => a?.PARENTITEMCODE === item.OM_ITEM_CODE,
                          );
                          const hasAddons =
                            itemAccList?.length > 0 || itemAuxList?.length > 0;

                          const accTotal = getChildQtyTotal(
                            item.OM_ITEM_CODE,
                            "ACCOMPANIMENT",
                          );
                          const auxTotal = getChildQtyTotal(
                            item.OM_ITEM_CODE,
                            "AUXILIARY",
                          );
                          const accComplete =
                            itemAccList?.length > 0 ? accTotal >= qty : true;
                          const auxComplete =
                            itemAuxList?.length > 0 ? auxTotal >= qty : true;
                          const addonsComplete =
                            qty > 0 && accComplete && auxComplete;

                          // Adding the parent — no popup opens here anymore
                          const handleAddParent = (e) => {
                            e.stopPropagation();
                            if (hasAddons) {
                              addParentItem(item);
                            } else {
                              handleRowClickItem(item);
                            }
                          };

                          // Explicitly triggered once the user is happy with the parent qty
                          const handleOpenAddons = (e) => {
                            e.stopPropagation();
                            setSelectedParentItem(item);
                            if (itemAuxList?.length > 0) {
                              const auxiliaryCodes = new Set(
                                itemAuxList
                                  .map((i) => i.ACCOMPANIMENTITEMCODE)
                                  .filter(Boolean),
                              );
                              setAuxiliaryList(
                                allProdsList?.filter((i) =>
                                  auxiliaryCodes.has(i.OM_ITEM_CODE),
                                ),
                              );
                            } else {
                              setAuxiliaryList([]);
                            }

                            if (itemAccList?.length > 0) {
                              const accompanimentCodes = new Set(
                                itemAccList
                                  .map((i) => i.ACCOMPANIMENTITEMCODE)
                                  .filter(Boolean),
                              );
                              setAccompanionList(
                                allProdsList?.filter((i) =>
                                  accompanimentCodes.has(i.OM_ITEM_CODE),
                                ),
                              );
                              setShowAccompanionItem(true); // starts with accompaniment
                            } else if (itemAuxList?.length > 0) {
                              // no accompaniments configured — go straight to auxiliary
                              setShowAuxiliaryItem(true);
                            }
                          };

                          return (
                            <aside
                              key={item.OM_ITEM_CODE}
                              tabIndex={0}
                              className="rounded-md border border-black shadow-xl text-center p-2 ml-2 mt-2 cursor-pointer w-32 sm:w-36 flex flex-col items-center"
                              onClick={qty === 0 ? handleAddParent : undefined}
                            >
                              {/* {item.CATEGORYIMAGE?.data ? (
                                <img
                                  className="text-amber-950"
                                  src={URL.createObjectURL(
                                    new Blob(
                                      [
                                        new Uint8Array(
                                          item.CATEGORYIMAGE?.data,
                                        ),
                                      ],
                                      {
                                        type: "image/jpeg",
                                      },
                                    ),
                                  )}
                                />
                              ) : (
                                <IoFastFoodOutline
                                  size={40}
                                  className="text-[#002e62]"
                                />
                              )} */}
                              <p className="text-xs font-bold">
                                {item.OM_ITEM_DESCRIPTION}
                              </p>
                              <div className="flex">
                                <span className="text-xs font-semibold text-red-600">
                                  Price :
                                </span>
                                <p className="text-xs">{item.SELLINGPRICE}</p>
                              </div>
                              {qty > 0 ? (
                                <>
                                  <div className="flex items-center justify-center border border-black rounded-md mt-2 overflow-hidden">
                                    <button
                                      className="px-3 py-1 bg-red-600 text-white"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        updateItemQty(
                                          selectedItem.rowId,
                                          "dec",
                                        );
                                      }}
                                    >
                                      -
                                    </button>
                                    <span className="px-4 font-bold">
                                      {qty}
                                    </span>
                                    <button
                                      className="px-3 py-1 bg-green-600 text-white"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        updateItemQty(
                                          selectedItem.rowId,
                                          "inc",
                                        );
                                      }}
                                    >
                                      +
                                    </button>
                                  </div>
                                  {hasAddons && (
                                    <button
                                      className={`mt-2 text-[11px] font-semibold rounded-md px-2 py-1 border ${
                                        addonsComplete
                                          ? "bg-green-600 border-green-700 text-white"
                                          : "bg-amber-500 border-amber-600 text-white"
                                      }`}
                                      onClick={handleOpenAddons}
                                    >
                                      {addonsComplete
                                        ? "Add-ons ✓"
                                        : `Add-ons (Acc ${accTotal}/${qty}, Aux ${auxTotal}/${qty})`}
                                    </button>
                                  )}
                                </>
                              ) : (
                                <button
                                  className="border border-black rounded-md flex justify-center items-center py-[2px] px-[5px] cursor-pointer text-white bg-[#002e62dd] m-[10px]"
                                  onClick={handleAddParent}
                                >
                                  Add &nbsp;
                                  <FaShoppingCart />
                                </button>
                              )}
                            </aside>
                          );
                        })}
                        {/* ACCOMPANIMENT POPUP — shown first */}
                        {showAcompanionItem && acompanionList?.length > 0 && (
                          <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-2">
                            <div className="bg-white rounded-lg shadow-2xl w-full max-w-5xl max-h-[80vh] overflow-hidden">
                              <div className="flex justify-between items-center border-b px-5 py-3">
                                <div>
                                  <h2 className="font-bold text-lg">
                                    Accompanion List
                                  </h2>
                                  {selectedParentItem && (
                                    <p className="text-xs text-gray-500">
                                      {getChildQtyTotal(
                                        selectedParentItem.OM_ITEM_CODE,
                                        "ACCOMPANIMENT",
                                      )}{" "}
                                      /{" "}
                                      {getParentRow(selectedParentItem)?.QTY ||
                                        0}{" "}
                                      selected
                                    </p>
                                  )}
                                </div>
                                <button
                                  onClick={closeAccompanionPopup}
                                  className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded"
                                >
                                  {auxiliaryList?.length > 0
                                    ? "Next: Auxiliary →"
                                    : "✕ Close"}
                                </button>
                              </div>
                              <div className="p-4 flex flex-wrap justify-center sm:justify-start gap-3 overflow-y-auto max-h-[65vh]">
                                {acompanionList.map((item) => {
                                  const selectedItem =
                                    itemsListFromTakeOrder?.find(
                                      (value) =>
                                        value["ITEM CODE"] ===
                                          item.OM_ITEM_CODE &&
                                        value["ITEM NAME"] ===
                                          item.OM_ITEM_DESCRIPTION &&
                                        value["PARENT_ITEM_CODE"] ===
                                          selectedParentItem?.OM_ITEM_CODE &&
                                        value["ADDON_TYPE"] === "ACCOMPANIMENT",
                                    );
                                  const qty = selectedItem?.QTY || 0;

                                  return (
                                    <aside
                                      key={item.OM_ITEM_CODE}
                                      className="rounded-md border border-black shadow-xl text-center p-2 w-32 sm:w-36 flex flex-col items-center"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        // handleRowClickItem(
                                        //   item,
                                        //   selectedParentItem,
                                        //   "ACCOMPANIMENT",
                                        // );
                                      }}
                                    >
                                      {item.CATEGORYIMAGE?.data ? (
                                        <img
                                          src={URL.createObjectURL(
                                            new Blob(
                                              [
                                                new Uint8Array(
                                                  item.CATEGORYIMAGE.data,
                                                ),
                                              ],
                                              {
                                                type: "image/jpeg",
                                              },
                                            ),
                                          )}
                                        />
                                      ) : (
                                        <IoFastFoodOutline
                                          size={40}
                                          className="text-[#002e62]"
                                        />
                                      )}
                                      <p className="text-xs font-bold">
                                        {item.OM_ITEM_DESCRIPTION}
                                      </p>
                                      <div className="flex">
                                        <span className="text-xs font-semibold text-red-600">
                                          Price :
                                        </span>
                                        <p className="text-xs">
                                          {item.SELLINGPRICE}
                                        </p>
                                      </div>
                                      {qty > 0 ? (
                                        <div className="flex items-center justify-center border border-black rounded-md mt-2 overflow-hidden">
                                          <button
                                            className="px-3 py-1 bg-red-600 text-white"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              updateItemQty(
                                                selectedItem.rowId,
                                                "dec",
                                              );
                                            }}
                                          >
                                            -
                                          </button>
                                          <span className="px-4 font-bold">
                                            {qty}
                                          </span>
                                          <button
                                            className="px-3 py-1 bg-green-600 text-white"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              updateItemQty(
                                                selectedItem.rowId,
                                                "inc",
                                              );
                                            }}
                                          >
                                            +
                                          </button>
                                        </div>
                                      ) : (
                                        <button
                                          className="border border-black rounded-md flex justify-center items-center py-[2px] px-[5px] cursor-pointer text-white bg-[#002e62dd] m-[10px]"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleRowClickItem(
                                              item,
                                              selectedParentItem,
                                              "ACCOMPANIMENT",
                                            );
                                          }}
                                        >
                                          Add &nbsp;
                                          <FaShoppingCart />
                                        </button>
                                      )}
                                    </aside>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        )}

                        {showAuxiliaryItem && auxiliaryList?.length > 0 && (
                          <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-2">
                            <div className="bg-white rounded-lg shadow-2xl w-full max-w-5xl max-h-[80vh] overflow-hidden">
                              <div className="flex justify-between items-center border-b px-5 py-3">
                                <div>
                                  <h2 className="font-bold text-lg">
                                    Auxiliary List
                                  </h2>
                                  {selectedParentItem && (
                                    <p className="text-xs text-gray-500">
                                      {getChildQtyTotal(
                                        selectedParentItem.OM_ITEM_CODE,
                                        "AUXILIARY",
                                      )}{" "}
                                      /{" "}
                                      {getParentRow(selectedParentItem)?.QTY ||
                                        0}{" "}
                                      selected
                                    </p>
                                  )}
                                </div>
                                <button
                                  onClick={closeAuxiliaryPopup}
                                  className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded"
                                >
                                  ✕ Close
                                </button>
                              </div>
                              <div className="p-4 flex flex-wrap justify-center sm:justify-start gap-3 overflow-y-auto max-h-[65vh]">
                                {auxiliaryList.map((item) => {
                                  const selectedItem =
                                    itemsListFromTakeOrder?.find(
                                      (value) =>
                                        value["ITEM CODE"] ===
                                          item.OM_ITEM_CODE &&
                                        value["ITEM NAME"] ===
                                          item.OM_ITEM_DESCRIPTION &&
                                        value["PARENT_ITEM_CODE"] ===
                                          selectedParentItem?.OM_ITEM_CODE &&
                                        value["ADDON_TYPE"] === "AUXILIARY",
                                    );
                                  const qty = selectedItem?.QTY || 0;

                                  return (
                                    <aside
                                      key={item.OM_ITEM_CODE}
                                      className="rounded-md border border-black shadow-xl text-center p-2 w-32 sm:w-36 flex flex-col items-center"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        // handleRowClickItem(
                                        //   item,
                                        //   selectedParentItem,
                                        //   "AUXILIARY",
                                        // );
                                      }}
                                    >
                                      {item.CATEGORYIMAGE?.data ? (
                                        <img
                                          src={URL.createObjectURL(
                                            new Blob(
                                              [
                                                new Uint8Array(
                                                  item.CATEGORYIMAGE.data,
                                                ),
                                              ],
                                              {
                                                type: "image/jpeg",
                                              },
                                            ),
                                          )}
                                        />
                                      ) : (
                                        <IoFastFoodOutline
                                          size={40}
                                          className="text-[#002e62]"
                                        />
                                      )}
                                      <p className="text-xs font-bold">
                                        {item.OM_ITEM_DESCRIPTION}
                                      </p>
                                      <div className="flex">
                                        <span className="text-xs font-semibold text-red-600">
                                          Price :
                                        </span>
                                        <p className="text-xs">
                                          {item.SELLINGPRICE}
                                        </p>
                                      </div>
                                      {qty > 0 ? (
                                        <div className="flex items-center justify-center border border-black rounded-md mt-2 overflow-hidden">
                                          <button
                                            className="px-3 py-1 bg-red-600 text-white"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              updateItemQty(
                                                selectedItem.rowId,
                                                "dec",
                                              );
                                            }}
                                          >
                                            -
                                          </button>
                                          <span className="px-4 font-bold">
                                            {qty}
                                          </span>
                                          <button
                                            className="px-3 py-1 bg-green-600 text-white"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              updateItemQty(
                                                selectedItem.rowId,
                                                "inc",
                                              );
                                            }}
                                          >
                                            +
                                          </button>
                                        </div>
                                      ) : (
                                        <button
                                          className="border border-black rounded-md flex justify-center items-center py-[2px] px-[5px] cursor-pointer text-white bg-[#002e62dd] m-[10px]"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleRowClickItem(
                                              item,
                                              selectedParentItem,
                                              "AUXILIARY",
                                            );
                                          }}
                                        >
                                          Add &nbsp;
                                          <FaShoppingCart />
                                        </button>
                                      )}
                                    </aside>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Order items table */}
          <div className="w-full h-auto p-1">
            {ShowTable && (
              <aside className="table__pos__app text-sm overflow-x-auto">
                <table class="custom-table w-full">
                  <thead class="header-cell">
                    <tr>
                      <td className="text-left whitespace-nowrap">
                        Product Code
                      </td>
                      <td className="text-left whitespace-nowrap">
                        Product Name
                      </td>
                      <td className="text-right whitespace-nowrap">Quantity</td>
                      <td className="text-right whitespace-nowrap">
                        Rate (Exclusive)
                      </td>
                      <td className="text-right whitespace-nowrap">
                        VAT Amount
                      </td>
                      <td className="text-right whitespace-nowrap">
                        Levy Amount
                      </td>
                      <td className="text-right whitespace-nowrap">
                        Rate (Inclusive)
                      </td>
                      <td className="text-right whitespace-nowrap">
                        Total Amount
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {itemsListFromTakeOrder?.length > 0 &&
                      itemsListFromTakeOrder?.map((value, index) => (
                        <tr
                          key={value?.ITEMCODE}
                          className={
                            index < itemsListFromTakeOrder.length
                              ? "border-b cursor-pointer text-sm table-row"
                              : ""
                          }
                          onClick={() => fetchBackItems(value,index)}
                        >
                          <td className="whitespace-nowrap">
                            {value["ITEM CODE"] ? value["ITEM CODE"] : ""}
                          </td>
                          <td style={{ maxWidth: "250px" }}>
                            {value["ITEM NAME"] ? value["ITEM NAME"] : ""}
                          </td>
                          <td className="text-right whitespace-nowrap">
                            {value.QTY ? value.QTY : ""}
                          </td>
                          <td className="text-right whitespace-nowrap">
                            {value["ITEM RATE"]
                              ? value["ITEM RATE"]?.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              : 0.0}
                          </td>
                          <td className="text-right whitespace-nowrap">
                            {value?.["VAT AMOUNT"]
                              ? value?.["VAT AMOUNT"]?.toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  },
                                )
                              : 0.0}
                          </td>
                          <td className="text-right whitespace-nowrap">
                            {value?.["LEVY AMOUNT"]
                              ? value?.["LEVY AMOUNT"]?.toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  },
                                )
                              : 0.0}
                          </td>
                          <td className="text-right whitespace-nowrap">
                            {value["ITEM VALUE"]
                              ? value["ITEM VALUE"]?.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              : 0.0}
                          </td>
                          <td className="text-right whitespace-nowrap">
                            {value.QTY
                              ? (
                                  Number(value.QTY) *
                                  Number(value["ITEM VALUE"])
                                )?.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              : 0.0}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </aside>
            )}
          </div>

          <div className="w-full h-auto lg:flex flex-row">
            {showReceipts && (
              <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/20 p-2">
                <div className="relative bg-white border border-black h-[90vh] lg:h-[calc(100vh-90px)] w-full lg:w-[1300px] p-1 overflow-y-auto rounded-md shadow-xl">
                  <Receipt hideNavBar={true} cashPoToPass={cashPo} />
                  <button
                    className="absolute top-1 right-1 flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 focus:outline-none focus:ring focus:border-blue-300"
                    onClick={() => setShowReceipts(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
              )}
              

              {/* Merge Bills */}
               {showMergeBills && (
              <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/20 p-2">
                <div className="relative bg-white border border-black h-[90vh] lg:h-[calc(100vh-90px)] w-full lg:w-[1300px] p-1 overflow-y-auto rounded-md shadow-xl">
                  <BILLMERGING hideNavBar={true} />
                  <button
                    className="absolute top-1 right-1 flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 focus:outline-none focus:ring focus:border-blue-300"
                    onClick={() => setShowMergeBills(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            )}

              {/* Split Bills */}
               {showSplitBills && (
              <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/20 p-2">
                <div className="relative bg-white border border-black h-[90vh] lg:h-[calc(100vh-90px)] w-full lg:w-[1300px] p-1 overflow-y-auto rounded-md shadow-xl">
                  <BILLSPLITTING hideNavBar={true} cashPoToPass={newCashPOSNo} />
                  <button
                    className="absolute top-1 right-1 flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 focus:outline-none focus:ring focus:border-blue-300"
                    onClick={() => setShowSplitBills(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            )}


            {/* Right side totals */}
            <div className="flex flex-col sm:flex-row flex-wrap lg:ml-2 gap-2 mx-2 lg:mx-0 mt-2">
              <div className="flex items-center gap-2">
                <p>Number of Items:</p>
                <input
                  className="w-14 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                  value={
                    itemsListFromTakeOrder?.length > 0
                      ? itemsListFromTakeOrder?.length
                      : ""
                  }
                  readOnly
                />
              </div>
              <div className="flex items-center gap-2">
                <p>Vat % and Amt:</p>
                <input
                  className="w-14 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                  value={
                    vatperc != null
                      ? vatperc?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "0"
                  }
                  readOnly
                />
                <input
                  className="w-20 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                  value={
                    totalVatOT
                      ? totalVatOT?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "0"
                  }
                  readOnly
                />
              </div>
              <div className="flex items-center gap-2">
                <p>Levy % and Amt:</p>
                <input
                  className="w-14 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                  value={
                    hlevyperc
                      ? hlevyperc?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : levyperc != null
                        ? levyperc?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        : "0"
                  }
                  readOnly
                />
                <input
                  className="w-20 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                  value={
                    totalLevyOT
                      ? totalLevyOT?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "0"
                  }
                  readOnly
                />
              </div>
              <div className="flex items-center gap-2">
                <p>Grand Total:</p>
                <input
                  className="w-24 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                  value={
                    itemsListFromTakeOrder?.length > 0
                      ? grandtotalOT?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : ""
                  }
                  readOnly
                />
              </div>
            </div>
          </div>

          {/* Print */}
          {PopUpReport && (
            <div>
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 99,
                }}
              />

              <div
                style={{
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: "white",
                  border: "1px solid black",
                  height: "80%",
                  width: "90%",
                  maxWidth: "90%",
                  maxHeight: "600px",
                  padding: "16px",
                  zIndex: 100,
                  overflowY: "auto",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                }}
              >
                {LoadingScreenBlock && <LoadingSpinner />}
                <button
                  className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2 focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => setPopUpReport(false)}
                >
                  Close
                </button>

                <section className="lg:flex lg:flex-col bg-white p-4 gap-2 shadow-lg rounded-md w-full min-h-[500px]">
                  <div>
                    <section className="lg:hidden block">
                      {pdfData && (
                        <button
                          className="bg-blue-500 text-white rounded-md px-2 py-1 block my-1"
                          onClick={handleDownload}
                        >
                          Download PDF
                        </button>
                      )}
                    </section>

                    <section className="hidden lg:block">
                      {pdfData ? (
                        <div className="w-full justify-center items-center min-h-screen p-4">
                          <section className="lg:flex lg:flex-col bg-white p-4 shadow-lg rounded-md w-full min-h-[500px]">
                            <div>
                              <section className="lg:hidden block">
                                {pdfData && (
                                  <button
                                    className="bg-blue-900 text-white h-7 text-lg rounded-md px-3 ml-2 mr-2 focus:outline-none focus:ring"
                                    onClick={handleDownload}
                                  >
                                    Download PDF
                                  </button>
                                )}
                              </section>

                              <section className="hidden lg:block">
                                {pdfData ? (
                                  <div className="mt-4">
                                    <h2 className="text-lg font-bold">
                                      Generated Report
                                    </h2>
                                    <iframe
                                      src={pdfData}
                                      title="Generated Report"
                                      className="w-full h-[60vh] sm:h-[600px]"
                                    ></iframe>
                                  </div>
                                ) : (
                                  <p className="text-2xl font-bold my-4 text-center">
                                    No report available.
                                  </p>
                                )}
                              </section>
                            </div>
                          </section>
                        </div>
                      ) : (
                        ""
                      )}
                    </section>
                  </div>
                </section>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default CreditNoteCash;
